{
  "app": {
    "name": "فيدلِن",
    "tagline": "نظام تشغيل المشتريات المركزي",
    "loading": "جارٍ التحميل…",
    "saving": "جارٍ الحفظ…",
    "retry": "إعادة المحاولة",
    "cancel": "إلغاء",
    "save": "حفظ",
    "create": "إنشاء",
    "edit": "تعديل",
    "archive": "أرشفة",
    "search": "بحث",
    "filter": "تصفية",
    "clear": "مسح",
    "confirm": "تأكيد",
    "close": "إغلاق",
    "back": "رجوع",
    "next": "التالي",
    "previous": "السابق",
    "reason": "السبب",
    "recordedText": "النص كما سُجِّل",
    "optional": "اختياري",
    "yes": "نعم",
    "no": "لا",
    "actions": "إجراءات",
    "status": "الحالة",
    "none": "لا يوجد",
    "all": "الكل",
    "activate": "تفعيل",
    "deactivate": "إيقاف",
    "delete": "حذف",
    "archiveNotice": "الأرشفة تسحب هذا السجل من الاستخدام. يُحتفظ بالسجلات التاريخية التي تشير إليه، ولا يمكن التراجع عن الأرشفة.",
    "select": "اختر…",
    "notes": "ملاحظات",
    "fixFields": "كل مشكلة أدناه تنقلك إلى حقلها:",
    "dismiss": "إغلاق"
  },
  "auth": {
    "signIn": "تسجيل الدخول",
    "signOut": "تسجيل الخروج",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "organisation": "المنشأة",
    "signingIn": "جارٍ تسجيل الدخول…",
    "welcome": "مرحباً بك في فيدلِن",
    "signInSubtitle": "سجّل الدخول للوصول إلى مساحة عمل منشأتك"
  },
  "mfa": {
    "signedInAs": "تسجيل الدخول باسم",
    "expiredTitle": "انتهت مهلة تسجيل الدخول",
    "expiredBody": "حفاظًا على أمانك يجب إكمال الخطوة الثانية خلال دقائق من إدخال كلمة المرور. سجّل الدخول مرة أخرى للمتابعة.",
    "signInAgain": "تسجيل الدخول مرة أخرى",
    "code": "الرمز المكوّن من 6 أرقام",
    "codeHint": "يتغيّر الرمز كل 30 ثانية. اكتب الرمز الظاهر في التطبيق الآن.",
    "codeRequired": "اكتب الرمز المكوّن من 6 أرقام من تطبيق المصادقة",
    "recoveryCode": "رمز الاسترداد",
    "recoveryCodeRequired": "اكتب أحد رموز الاسترداد الخاصة بك",
    "verify": "تحقّق",
    "verifying": "جارٍ التحقق…",
    "copied": "تم النسخ",
    "challenge": {
      "title": "أدخل رمز تطبيق المصادقة",
      "body": "افتح تطبيق المصادقة على هاتفك واكتب الرمز المكوّن من 6 أرقام الظاهر لحساب فيدلِن.",
      "useRecovery": "استخدام رمز استرداد بدلًا من ذلك"
    },
    "recovery": {
      "title": "استخدام رمز استرداد",
      "body": "اكتب أحد رموز الاسترداد التي حفظتها عند إعداد التحقق بخطوتين. كل رمز يعمل مرة واحدة فقط.",
      "useAuthenticator": "استخدام تطبيق المصادقة بدلًا من ذلك",
      "doneTitle": "سجّلت الدخول برمز استرداد",
      "doneBody": "لم يعد ذلك الرمز صالحًا. كل رمز استرداد يُدخلك مرة واحدة، فاحتفظ بالرموز الأخرى في مكان آمن.",
      "lostPhone": "إن لم يعد تطبيق المصادقة لديك فاستبدله الآن، ويؤكد رمز استرداد آخر هويتك.",
      "replaceNow": "استبدال تطبيق المصادقة",
      "remaining": "رموز الاسترداد المتبقية: {{count}}",
      "continue": "متابعة"
    },
    "enrol": {
      "title": "إعداد التحقق بخطوتين",
      "body": "يتطلب دورك خطوة ثانية عند تسجيل الدخول: رمزًا من تطبيق مصادقة على هاتفك. يستغرق الإعداد نحو دقيقتين.",
      "need": "ستحتاج إلى تطبيق مصادقة على هاتفك. يصلح أي تطبيق يدعم الرموز المؤقتة.",
      "start": "بدء الإعداد",
      "scanTitle": "أضف فيدلِن إلى تطبيق المصادقة",
      "scanBody": "في تطبيق المصادقة أضف حسابًا جديدًا وامسح رمز QR هذا.",
      "qrAlt": "رمز QR يضيف فيدلِن إلى تطبيق المصادقة",
      "manualKey": "لا تستطيع المسح؟ اكتب مفتاح الإعداد هذا في التطبيق بدلًا من ذلك:",
      "copyKey": "نسخ المفتاح",
      "expires": "أكمل الإعداد قبل {{time}}.",
      "confirmCode": "الرمز من التطبيق",
      "confirmHint": "اكتب الرمز المكوّن من 6 أرقام الذي يظهره التطبيق الآن لحساب فيدلِن.",
      "confirm": "تأكيد",
      "restart": "البدء من جديد برمز QR جديد"
    },
    "codes": {
      "title": "احفظ رموز الاسترداد",
      "once": "تظهر هذه الرموز هذه المرة فقط. إن فقدت هاتفك فكل رمز يتيح لك تسجيل الدخول مرة واحدة. احفظها في مكان آمن غير هاتفك، مثل مدير كلمات المرور أو نسخة مطبوعة محفوظة في مكان مقفل.",
      "listLabel": "رموز الاسترداد الخاصة بك",
      "copy": "نسخ كل الرموز",
      "stored": "حفظتُ هذه الرموز في مكان آمن",
      "storedRequired": "أكّد أنك حفظت الرموز قبل المتابعة",
      "continue": "متابعة"
    },
    "reauth": {
      "body": "أدخل كلمة المرور والرمز الظاهر الآن في تطبيق المصادقة.",
      "bodyRecovery": "أدخل كلمة المرور وأحد رموز الاسترداد التي لم تستخدمها. لن يعمل ذلك الرمز بعد ذلك.",
      "passwordRequired": "أدخل كلمة المرور",
      "continue": "متابعة"
    },
    "security": {
      "title": "أمان تسجيل الدخول",
      "subtitle": "كيف تثبت هويتك عند تسجيل الدخول",
      "cardTitle": "التحقق بخطوتين",
      "cardSubtitle": "كلمة المرور، ثم رمز من تطبيق المصادقة",
      "status": "الحالة",
      "on": "مفعّل",
      "off": "غير مفعّل",
      "requirement": "لدورك",
      "required": "إلزامي",
      "optional": "اختياري",
      "since": "تاريخ الإعداد",
      "codesLeft": "رموز الاسترداد المتبقية",
      "codesLow": "بقي لديك عدد قليل من رموز الاسترداد. أنشئ رموزًا جديدة.",
      "offBody": "التحقق بخطوتين غير مفعّل. دورك لا يتطلبه، لكنه يجعل اختراق حسابك أصعب بكثير.",
      "setUp": "إعداد التحقق بخطوتين",
      "replace": "استبدال تطبيق المصادقة",
      "replaceHint": "عند الانتقال إلى هاتف جديد. يبقى تطبيقك الحالي صالحًا حتى تؤكد التطبيق الجديد.",
      "replaceTitle": "استبدال تطبيق المصادقة",
      "regenerate": "إنشاء رموز استرداد جديدة",
      "regenerateHint": "تتوقف رموز الاسترداد الحالية عن العمل فور إنشاء الرموز الجديدة.",
      "regenerateTitle": "إنشاء رموز استرداد جديدة",
      "disable": "إيقاف التحقق بخطوتين",
      "disableHint": "ستسجّل الدخول بكلمة المرور فقط.",
      "disableTitle": "إيقاف التحقق بخطوتين",
      "requiredNote": "يتطلب دورك التحقق بخطوتين، لذا لا يمكن إيقافه.",
      "setupDone": "التحقق بخطوتين مفعّل الآن.",
      "replaced": "تطبيق المصادقة الجديد قيد الاستخدام، ولم يعد القديم صالحًا.",
      "regenerated": "رموز الاسترداد الجديدة جاهزة، ولم تعد القديمة صالحة.",
      "disabled": "تم إيقاف التحقق بخطوتين.",
      "changedElsewhere": "تغيّر أمان تسجيل الدخول من نافذة أو جهاز آخر. لم يتغيّر شيء هنا، وتعرض هذه الصفحة الآن وضعه الحالي."
    }
  },
  "activation": {
    "title": "تفعيل حسابك",
    "subtitle": "اختر كلمة مرور ليصبح حسابك جاهزاً",
    "checking": "جارٍ التحقق من الدعوة…",
    "password": "اختر كلمة المرور",
    "passwordHint": "كلمة تتذكرها ولا يستطيع غيرك تخمينها",
    "confirmPassword": "أعد كتابة كلمة المرور",
    "passwordRequired": "أدخل كلمة المرور",
    "passwordMismatch": "كلمتا المرور غير متطابقتين",
    "activate": "تفعيل حسابي",
    "activating": "جارٍ التفعيل…",
    "expires": "ينتهي العمل بهذا الرابط في {{date}}",
    "unavailableTitle": "لا يمكن استخدام هذا الرابط",
    "unavailableBody": "اطلب ممن دعاك أن يرسل لك رابط دعوة جديداً.",
    "successTitle": "حسابك جاهز",
    "successBody": "يمكنك الآن تسجيل الدخول باستخدام {{email}}."
  },
  "nav": {
    "dashboard": "لوحة المعلومات",
    "organization": "الهيكل التنظيمي",
    "regions": "المناطق",
    "warehouses": "المستودعات",
    "categories": "الفئات",
    "administration": "الإدارة",
    "users": "المستخدمون",
    "roles": "الأدوار",
    "delegations": "التفويضات",
    "currencies": "العملات",
    "taxCodes": "رموز الضريبة",
    "settings": "الإعدادات",
    "audit": "سجل التدقيق",
    "profile": "الملف الشخصي",
    "suppliers": "الموردون",
    "agreements": "الاتفاقيات الإطارية",
    "catalogue": "الكتالوج",
    "procurement": "المشتريات",
    "vendorPortal": "بوابة الموردين",
    "budgets": "الميزانيات",
    "approvalRules": "قواعد الاعتماد",
    "policy": "السياسات",
    "cart": "السلة",
    "myRequests": "طلباتي",
    "approvals": "الاعتمادات",
    "purchaseOrders": "أوامر الشراء",
    "vendorOrders": "الأوامر",
    "purchasingUnits": "وحدات الشراء",
    "receiving": "الاستلام",
    "sourcing": "التوريد",
    "onboarding": "التهيئة والاستيراد",
    "reports": "التقارير",
    "catalogueAdmin": "إدارة الكتالوج",
    "organizationProfile": "ملف المنشأة",
    "account": "حسابك",
    "signInSecurity": "أمان تسجيل الدخول",
    "more": "المزيد"
  },
  "status": {
    "active": "نشط",
    "inactive": "غير نشط",
    "archived": "مؤرشف",
    "invited": "مدعو",
    "suspended": "موقوف",
    "scheduled": "مجدول",
    "expired": "منتهٍ",
    "revoked": "ملغى",
    "terminated": "منتهية",
    "under_review": "قيد المراجعة",
    "qualified": "مؤهَّل"
  },
  "enums": {
    "request_status": {
      "draft": "مسودة",
      "pending_approval": "بانتظار الاعتماد",
      "approved": "معتمد",
      "returned": "مُعاد للتعديل",
      "rejected": "مرفوض",
      "cancelled": "ملغى",
      "procurement_review": "لدى المشتريات",
      "sourcing_required": "يتطلب توريداً",
      "procurement_processing": "قيد المعالجة لدى المشتريات",
      "po_created": "تم إنشاء أوامر الشراء"
    },
    "approval_status": {
      "pending": "قيد الاعتماد",
      "approved": "معتمد",
      "rejected": "مرفوض",
      "returned": "مُعاد للتعديل",
      "skipped": "متجاوز",
      "cancelled": "ملغى"
    },
    "budget_health": {
      "within": "ضمن الميزانية",
      "warning": "اقتراب من الحد",
      "exceeded": "تجاوز الميزانية",
      "no_budget": "لا توجد ميزانية"
    },
    "purchasing_unit_kind": {
      "branch": "فرع",
      "warehouse": "مستودع",
      "head_office": "المركز الرئيسي",
      "department": "إدارة",
      "business_unit": "وحدة أعمال",
      "project_site": "موقع مشروع",
      "clinic": "عيادة",
      "school": "مدرسة",
      "other": "أخرى"
    },
    "purchasing_unit_status": {
      "draft": "مسودة",
      "active": "نشطة",
      "inactive": "موقوفة"
    },
    "receivingException": {
      "short": "نقص",
      "over": "تسليم زائد",
      "damaged": "تالف",
      "incorrect": "صنف غير صحيح",
      "rejected": "مرفوض",
      "overdue": "متأخر"
    },
    "budget_status": {
      "draft": "مسودة",
      "active": "نشطة",
      "frozen": "مجمّدة",
      "closed": "مغلقة"
    },
    "agreement_status": {
      "draft": "مسودة",
      "active": "نشطة",
      "suspended": "معلّقة",
      "expired": "منتهية",
      "terminated": "منهاة"
    }
  },
  "region": {
    "title": "المناطق",
    "subtitle": "تجميع وحدات الشراء لأغراض الصلاحيات والتقارير",
    "code": "الرمز",
    "nameEn": "الاسم بالإنجليزية",
    "nameAr": "الاسم بالعربية",
    "branchCount": "عدد وحدات الشراء",
    "create": "إضافة منطقة",
    "empty": "لم يتم إنشاء أي منطقة بعد",
    "archiveConfirm": "سيتم أرشفة هذه المنطقة. لا يمكن أرشفة منطقة تحتوي على وحدات شراء نشطة."
  },
  "branch": {
    "title": "وحدات الشراء",
    "code": "الرمز",
    "region": "المنطقة",
    "costCenter": "مركز التكلفة",
    "isReceiving": "موقع استلام"
  },
  "warehouse": {
    "title": "المستودعات",
    "subtitle": "مصادر تنفيذ داخلية للطلبات — دون محاسبة مخزون",
    "create": "إضافة مستودع",
    "empty": "لم يتم تعريف أي مستودع",
    "noStockNotice": "المستودعات في المرحلة الأولى مصادر توريد فقط ولا تتضمن أرصدة مخزون.",
    "single": "المستودع",
    "region": "المنطقة",
    "serves": "يخدم",
    "servesCount": "وحدات الشراء المخدومة: {{count}}",
    "servesNone": "لا يخدم أي وحدة شراء.",
    "servesNoneHint": "لا يمكنه تسعير أي صنف حتى يُسند إلى وحدة شراء.",
    "coverage": "التغطية",
    "coverageTitle": "تغطية المستودع",
    "coverageHint": "اختر وحدات الشراء التي يخدمها هذا المستودع. هذه خريطة تغطية — لا قاعدة توجيه ولا تخصيص مخزون.",
    "phone": "الهاتف",
    "email": "البريد الإلكتروني",
    "emptyHint": "أمر طبيعي تماماً — المنشأة التي تشتري كل شيء من الموردين لا تحتاج إلى مستودع."
  },
  "category": {
    "title": "الفئات",
    "subtitle": "شجرة فئات المنشأة مربوطة بأنواع المشتريات القياسية",
    "parent": "الفئة الأعلى",
    "standardType": "النوع القياسي",
    "depth": "المستوى",
    "create": "إضافة فئة",
    "empty": "لم يتم إنشاء أي فئة بعد",
    "tree": "الشجرة",
    "list": "القائمة",
    "edit": "تعديل الفئة",
    "topLevel": "المستوى الأعلى",
    "parentFixedNotice": "لا تُغيَّر الفئة الأم هنا. نقل الفئة ينقل معه كل ميزانية وقاعدة اعتماد وطلب سابق مرتبط بها."
  },
  "user": {
    "title": "المستخدمون",
    "subtitle": "الأشخاص والأدوار والنطاقات",
    "name": "الاسم",
    "nameAr": "الاسم بالعربية",
    "jobTitle": "المسمى الوظيفي",
    "roles": "الأدوار",
    "scope": "النطاق",
    "lastLogin": "آخر دخول",
    "create": "إضافة مستخدم",
    "activate": "تفعيل",
    "deactivate": "إيقاف",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "generatedPassword": "كلمة المرور المؤقتة",
    "generatedPasswordNotice": "انسخ كلمة المرور الآن — لن تُعرض مرة أخرى.",
    "scopeTenant": "المنشأة بالكامل",
    "scopeRegion": "منطقة",
    "scopeBranch": "وحدة شراء",
    "empty": "لا يوجد مستخدمون",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف"
  },
  "role": {
    "title": "الأدوار",
    "subtitle": "مجموعات الصلاحيات",
    "permissions": "الصلاحيات",
    "systemRole": "دور نظامي",
    "userCount": "عدد المستخدمين",
    "create": "إضافة دور",
    "cannotGrantNotice": "لا يمكنك منح صلاحية لا تملكها بنفسك.",
    "empty": "لا توجد أدوار بعد"
  },
  "delegation": {
    "title": "التفويضات",
    "subtitle": "تفويض صلاحية مؤقت ومحدد المدة",
    "delegator": "المُفوِّض",
    "delegate": "المُفوَّض له",
    "startsAt": "يبدأ في",
    "endsAt": "ينتهي في",
    "maxAmount": "الحد الأعلى للمبلغ",
    "revoke": "إلغاء التفويض",
    "revokeFor": "إلغاء التفويض الممنوح إلى {{name}}",
    "revokeTitle": "إلغاء هذا التفويض؟",
    "revokeBody": "يتوقف {{delegate}} فوراً عن التصرف نيابةً عن {{delegator}}. تبقى القرارات المتخذة سابقاً كما سُجِّلت.",
    "revokeFinal": "لا يمكن إعادة تفعيل التفويض بعد إلغائه. إن احتجت إليه مجدداً فأنشئ تفويضاً جديداً.",
    "revokeReasonHint": "اختياري. يُحفظ مع التغيير ليمكن تفسيره لاحقاً.",
    "revokeKeep": "إبقاء التفويض",
    "revokedTitle": "أُلغي التفويض",
    "revokedBody": "لم يعد بإمكان {{delegate}} التصرف نيابةً عن {{delegator}}. سُجِّل التغيير في سجل التدقيق مع من أجراه ومتى.",
    "revokedAudit": "فتح سجل التدقيق",
    "revokeForbidden": "لا يمكنك إلغاء هذا التفويض. يلغيه المُفوِّض الذي منحه، أو مدير النظام إن كان يملك صلاحية الإلغاء.",
    "revokeClosed": "هذا التفويض مغلق بالفعل، لذا لم يتغيّر شيء. تعرض القائمة الآن حالته الحالية.",
    "byGrantor": "يلغيه المُفوِّض فقط",
    "create": "إنشاء تفويض",
    "activeNow": "ساري الآن",
    "empty": "لا توجد تفويضات"
  },
  "finance": {
    "currencies": "العملات",
    "currency": "العملة",
    "currenciesSubtitle": "العملات المفعّلة لمنشأتك",
    "taxCodes": "رموز الضريبة",
    "taxCodesSubtitle": "معالجات ضريبية قابلة للتهيئة",
    "rate": "النسبة",
    "kind": "النوع",
    "isDefault": "افتراضي",
    "effectiveFrom": "ساري من",
    "effectiveTo": "ساري حتى",
    "enableCurrency": "تفعيل عملة",
    "rateToDefault": "سعر التحويل للعملة الافتراضية",
    "kinds": {
      "standard": "قياسية",
      "zero_rated": "نسبة صفرية",
      "exempt": "معفاة",
      "out_of_scope": "خارج النطاق",
      "reverse_charge": "احتساب عكسي"
    },
    "currenciesEmpty": "لا توجد عملات مفعّلة بعد"
  },
  "settings": {
    "title": "الإعدادات",
    "subtitle": "سلوك النظام قابل للتهيئة دون تعديل برمجي",
    "managedByFidelen": "تُدار بواسطة فيدلِن",
    "defaultValue": "القيمة الافتراضية",
    "requiresEntitlement": "يتطلب اشتراكاً",
    "configuredNotEffective": "تم الحفظ، لكنه غير مفعّل — هذه الإمكانية ليست ضمن اتفاقيتك مع فِدلن. تواصل معنا لتفعيلها.",
    "notIncluded": "هذه الإمكانية ليست ضمن اتفاقيتك مع فِدلن.",
    "on": "مفعّل",
    "off": "غير مفعّل",
    "approvalTypes": {
      "automatic": "دون اعتماد بشري",
      "exception_only": "اعتماد فقط عند مخالفة القواعد",
      "one_level": "مستوى اعتماد واحد",
      "two_level": "مستويان من الاعتماد"
    }
  },
  "audit": {
    "title": "سجل التدقيق",
    "subtitle": "من فعل ماذا ومتى",
    "action": "الإجراء",
    "actor": "المنفذ",
    "entity": "السجل",
    "channel": "القناة",
    "when": "التوقيت",
    "requestId": "معرّف الطلب",
    "empty": "لا توجد سجلات مطابقة",
    "domain": "المجال",
    "pickDomainFirst": "اختر المجال أولاً.",
    "domains": {
      "commercial": "الشؤون التجارية",
      "organization": "المنشأة",
      "identity": "المستخدمون والصلاحيات",
      "supplier": "الموردون",
      "approval": "الاعتمادات",
      "order": "أوامر الشراء",
      "request": "الطلبات",
      "platform": "المنصة",
      "agreement": "الاتفاقيات الإطارية",
      "budget": "الميزانيات",
      "catalogue": "الكتالوج",
      "sourcing": "التوريد",
      "security": "الأمان",
      "report": "التقارير",
      "receiving": "الاستلام",
      "onboarding": "التهيئة والاستيراد",
      "invoice": "الفواتير"
    }
  },
  "table": {
    "showing": "عرض {{from}}–{{to}} من {{total}}",
    "perPage": "لكل صفحة",
    "noResults": "لا توجد نتائج",
    "loadError": "تعذّر تحميل البيانات",
    "moreFields": "حقول أخرى ({{count}})",
    "pagination": "الصفحات",
    "page": "الصفحة {{page}}",
    "name": "الاسم",
    "noMatch": "لا شيء يطابق «{{search}}»",
    "noMatchHint": "تحقّق من الكتابة، أو امسح البحث لعرض كل شيء.",
    "clearSearch": "مسح البحث"
  },
  "filters": {
    "anyStatus": "كل الحالات",
    "anyone": "أي شخص",
    "purchasingNode": "وحدة الشراء",
    "from": "من",
    "to": "إلى",
    "dateRangeHelp": "يمكنك تحديد تاريخ واحد فقط إذا أردت.",
    "resetSelections": "مسح الاختيارات",
    "clearAll": "مسح الكل",
    "clearFilters": "مسح التصفية",
    "updating": "جارٍ تحديث النتائج…",
    "remove": "إزالة {{name}}"
  },
  "errors": {
    "IDEMPOTENCY_KEY_CONFLICT": "سبق إرسال هذا مرة بتفاصيل مختلفة، وقد نُفّذ ذلك الطلب الأول. حدّث الصفحة لترى ما سُجّل قبل المحاولة مرة أخرى.",
    "IDEMPOTENCY_REQUEST_IN_FLIGHT": "ما زال هذا قيد المعالجة. انتظر لحظة ثم حاول مرة أخرى.",
    "VALIDATION_FAILED": "بعض البيانات المُدخلة غير صحيحة.",
    "UNAUTHENTICATED": "انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.",
    "FORBIDDEN": "ليس لديك صلاحية تنفيذ هذا الإجراء.",
    "NOT_FOUND": "لم يتم العثور على السجل المطلوب.",
    "pageNotFound": "هذه الصفحة غير موجودة",
    "pageNotFoundBody": "تحقّق من الرابط، أو ارجع إلى الصفحة الرئيسية.",
    "CONFLICT": "هذا الإجراء يتعارض مع الحالة الحالية للسجل.",
    "RATE_LIMITED": "عدد كبير من الطلبات. يرجى الانتظار قليلاً.",
    "SERVER_ERROR": "حدث خطأ غير متوقع. تم تسجيل المشكلة.",
    "INVALID_CREDENTIALS": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
    "ACCOUNT_LOCKED": "تم إيقاف الحساب مؤقتاً بعد عدة محاولات فاشلة.",
    "ACCOUNT_INACTIVE": "هذا الحساب غير نشط. يرجى التواصل مع مدير النظام.",
    "TENANT_INACTIVE": "هذه المنشأة غير نشطة حالياً.",
    "DUPLICATE_CODE": "هذا الرمز مستخدم بالفعل.",
    "DUPLICATE_RECORD": "يوجد في منشأتك سجل بالبيانات نفسها بالفعل. افتح السجل الموجود بدلاً من ذلك.",
    "ENTITY_IN_USE": "هذا السجل قيد الاستخدام.",
    "CATEGORY_CYCLE_DETECTED": "لا يمكن وضع الفئة تحت نفسها.",
    "CATEGORY_DEPTH_EXCEEDED": "لا يمكن أن تتجاوز شجرة الفئات هذا العمق.",
    "PERMISSION_MISSING": "لا تملك الصلاحية اللازمة لهذا الإجراء.",
    "DELEGATION_OVERLAPS": "يوجد تفويض متداخل بالفعل.",
    "DELEGATION_SELF_TARGET": "لا يمكن تفويض الصلاحيات لنفسك.",
    "DELEGATION_INVALID_PERIOD": "فترة التفويض غير صحيحة.",
    "CAPACITY_EXCEEDED": "لا توجد سعة متبقية لدى منشأتك. أوقف وحدة أو تواصل معنا لزيادة السعة.",
    "RECORD_GOVERNED_BY_PURCHASING_UNIT": "هذا السجل تابع لوحدة شراء. أرشف وحدة الشراء أو أوقفها أو فعّلها من صفحة وحدات الشراء بدلاً من ذلك.",
    "PURCHASING_UNIT_ARCHIVED": "وحدة الشراء هذه مؤرشفة. يبقى سجلها متاحاً، لكنها لا تقبل سلات أو طلبات جديدة.",
    "PURCHASING_UNIT_DETAILS_ARCHIVED": "هذه التفاصيل مؤرشفة. لا تُؤرشَف وحدة الشراء إلا بإجراء الأرشفة الخاص بها في صفحة وحدات الشراء، لذا لا يمكن ربطها بتفاصيل مؤرشفة.",
    "PURCHASING_UNIT_DETAILS_SHARED": "وحدة شراء أخرى مرتبطة بهذه التفاصيل أيضاً. اربط تلك الوحدة بتفاصيل أخرى أولاً، ثم أرشف هذه الوحدة.",
    "ENTITLEMENT_REQUIRED": "هذه الإمكانية ليست ضمن اتفاقيتك الحالية مع فِدلن.",
    "SUBSCRIPTION_READ_ONLY": "حسابك للاطلاع فقط حالياً. يمكن إكمال الأعمال القائمة دون بدء أعمال جديدة.",
    "BUDGET_CLOSED_TO_NEW_SPEND": "هذه الميزانية مغلقة أمام أي إنفاق جديد. اختر ميزانية أخرى أو تواصل مع فريق المالية.",
    "BUDGET_INSUFFICIENT": "لا تغطي الميزانية هذا الطلب بسعره. راجع فريق المالية، ثم أعد التسعير.",
    "INVITATION_INVALID": "لا يمكن استخدام هذا الرابط. اطلب من الشخص الذي دعاك إرسال دعوة جديدة.",
    "METHOD_NOT_ALLOWED": "هذا الإجراء غير متاح هنا.",
    "PAYLOAD_TOO_LARGE": "ما أرسلته كبير جدًا. جرّب ملفًا أصغر.",
    "SERVICE_UNAVAILABLE": "الخدمة غير متاحة مؤقتًا. حاول مرة أخرى بعد دقائق.",
    "TENANT_CONTEXT_MISSING": "تعذّر التعرّف على منشأتك. سجّل الدخول مرة أخرى.",
    "TENANT_MISMATCH": "هذا السجل يخص منشأة أخرى.",
    "BRANCH_SCOPE_DENIED": "هذا خارج وحدات الشراء التي تعمل عليها.",
    "REGION_SCOPE_DENIED": "هذا خارج المناطق التي تعمل عليها.",
    "IDEMPOTENCY_KEY_REQUIRED": "تعذّر إرسال هذا الطلب بأمان. حدّث الصفحة وحاول مرة أخرى.",
    "TENANT_SELECTION_REQUIRED": "اختر المنشأة التي تريد الدخول إليها.",
    "LOGIN_SELECTION_INVALID": "لم يعد بالإمكان متابعة تسجيل الدخول هذا. سجّل الدخول مجدداً ببريدك الإلكتروني وكلمة المرور.",
    "DELEGATION_EXCEEDS_AUTHORITY": "لا يمكنك تفويض صلاحية أكبر مما لديك.",
    "PURCHASE_ORDER_NOT_DRAFT": "أمر الشراء هذا لم يعد مسودة.",
    "PURCHASE_ORDER_ISSUED": "صدر أمر الشراء هذا بالفعل.",
    "PURCHASE_ORDER_NOT_ISSUED": "لم يصدر أمر الشراء هذا بعد، أو أُلغي. حدّث الصفحة لمعرفة حالته.",
    "PURCHASE_ORDER_TERMINAL": "أمر الشراء هذا مغلق، ولا يمكن إجراء أي شيء آخر عليه.",
    "SUPPLIER_NOT_PROCURABLE": "لا يمكن الشراء من هذا المورد حاليًا. اختر موردًا آخر أو تواصل مع فريق المشتريات.",
    "ORDERED_QUANTITY_EXCEEDS_APPROVED": "الكمية أكبر مما تم اعتماده.",
    "SUPPLIER_CHANGE_NOT_PERMITTED": "لا يمكن تغيير المورد في هذا الأمر. ألغه وأنشئ أمرًا جديدًا.",
    "STALE_VERSION": "عدّل شخص آخر هذا أثناء عملك عليه. حدّث الصفحة لرؤية أحدث نسخة ثم حاول مرة أخرى.",
    "COMMITMENT_LEDGER_INCONSISTENT": "لا يطابق سجل الميزانية لهذا الأمر بنوده، ويلزم مراجعته قبل إلغاء الأمر.",
    "QUALIFICATION_REVIEW_REASON_REQUIRED": "يتطلب قرار التأهيل هذا سبب المراجعة أو الأدلة. اذكر ما جرى فحصه، مثل المستندات التي روجعت.",
    "ACTION_LINK_INVALID": "لا يمكن استخدام هذا الرابط. اطلب من المشتري إرسال رابط جديد.",
    "ACTION_LINK_EXPIRED": "لا يمكن استخدام هذا الرابط. اطلب من المشتري إرسال رابط جديد.",
    "ACTION_LINK_USED": "لا يمكن استخدام هذا الرابط. اطلب من المشتري إرسال رابط جديد.",
    "ACTION_LINK_REVOKED": "لا يمكن استخدام هذا الرابط. اطلب من المشتري إرسال رابط جديد.",
    "PLAN_VERSION_IMMUTABLE": "إصدار الخطة هذا مستخدم ولا يمكن تعديله. أنشئ إصدارًا جديدًا.",
    "INVALID_SUBSCRIPTION_TRANSITION": "لا يمكن نقل الاشتراك إلى هذه الحالة من حالته الحالية.",
    "SELF_APPROVAL_BLOCKED": "لا يمكنك اعتماد طلبك بنفسك، يجب أن يقرر فيه شخص آخر.",
    "SELF_RECEIPT_BLOCKED": "لا تسمح ضوابط منشأتك بأن تسجّل استلام هذه الشحنة بنفسك. يجب أن يسجّلها شخص آخر.",
    "SEGREGATION_OF_DUTIES_VIOLATION": "تمنعك قواعد الفصل بين المهام في منشأتك من القيام بذلك. يجب أن يقوم به شخص آخر.",
    "ENTITY_INACTIVE": "هذا العنصر غير نشط ولا يمكن استخدامه.",
    "CURRENCY_NOT_ENABLED": "هذه العملة غير مفعّلة لمنشأتك.",
    "CURRENCY_MISMATCH": "العملات غير متطابقة، ولا يمكن الجمع بين مبالغ بعملات مختلفة.",
    "TAX_CODE_INACTIVE": "رمز الضريبة هذا غير نشط.",
    "FILE_TYPE_NOT_ALLOWED": "هذا النوع من الملفات غير مقبول.",
    "FILE_TOO_LARGE": "هذا الملف كبير جدًا.",
    "FILE_SCAN_FAILED": "تعذّر فحص هذا الملف، لذا لم يُقبل.",
    "IMPORT_FILE_INVALID": "تعذّرت قراءة هذا الملف. استخدم القالب وحاول مرة أخرى.",
    "IMPORT_ROW_INVALID": "بعض الصفوف فيها مشكلات. راجع التقرير لكل صف.",
    "MFA_CHALLENGE_REQUIRED": "أكّد هويتك بالرمز الظاهر في تطبيق المصادقة للمتابعة.",
    "MFA_ENROLMENT_REQUIRED": "يتطلب دورك التحقق بخطوتين. أعدّه للمتابعة.",
    "MFA_REQUIRED_FOR_ROLE": "يتطلب دورك التحقق بخطوتين، لذا لا يمكن إيقافه.",
    "MFA_CODE_INVALID": "لم يعمل هذا الرمز. اكتب الرمز الظاهر في التطبيق الآن، أو رمز استرداد لم تستخدمه من قبل.",
    "MFA_ENROLMENT_EXPIRED": "انتهت صلاحية هذا الإعداد. ابدأ من جديد للحصول على رمز QR جديد.",
    "MFA_THROTTLED": "محاولات كثيرة جدًا. انتظر بضع دقائق ثم حاول مرة أخرى.",
    "MFA_REAUTH_FAILED": "كلمة المرور أو الرمز غير صحيح. حاول مرة أخرى.",
    "unknown": "حدث خطأ غير متوقع.",
    "APPROVAL_ROUTE_UNRESOLVABLE": "تعذّر توجيه هذا الطلب للاعتماد. يرجى مراجعة المسؤول لتعيين معتمد."
  },
  "a11y": {
    "mainNavigation": "التنقل الرئيسي",
    "quickNavigation": "التنقل السريع",
    "skipToContent": "تخطٍ إلى المحتوى",
    "toggleLanguage": "تبديل اللغة",
    "openMenu": "فتح القائمة",
    "closeMenu": "إغلاق القائمة",
    "closeDialog": "إغلاق هذه النافذة",
    "closeNamed": "إغلاق {{name}}",
    "dismiss": "إخفاء"
  },
  "supplier": {
    "title": "الموردون",
    "subtitle": "سجل الموردين الخاص بمنشأتك — يديره المقر الرئيسي",
    "code": "رمز المورد",
    "crNumber": "السجل التجاري",
    "vatNumber": "الرقم الضريبي",
    "status": "حالة التعامل",
    "qualificationStatus": "حالة التأهيل",
    "procurable": "قابل للشراء منه",
    "procurableOnly": "القابلون للشراء منهم فقط",
    "create": "إضافة مورد",
    "empty": "لم يتم تسجيل أي مورد بعد",
    "activate": "تفعيل التعامل",
    "suspend": "إيقاف التعامل",
    "archive": "إنهاء التعامل",
    "leadTime": "مدة التوريد (أيام)",
    "paymentTerms": "شروط الدفع",
    "website": "الموقع الإلكتروني",
    "branchNotice": "الموردون والأسعار المتعاقد عليها يديرها المقر الرئيسي فقط.",
    "twoGates": "يجب أن تكون حالة التعامل نشطة وحالة التأهيل نشطة معاً.",
    "name": "الاسم",
    "contacts": "جهات الاتصال",
    "primaryContact": "رئيسية",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف",
    "supplier": "المورّد",
    "contact": "التواصل",
    "importList": "استيراد قائمة",
    "searchPlaceholder": "ابحث بالاسم أو الرمز أو الرقم",
    "filterTitle": "تصفية الموردين",
    "showSuppliers": "عرض الموردين",
    "showCount": "عرض الموردين: {{count}}",
    "qualificationState": {
      "draft": "مسودة",
      "under_review": "قيد المراجعة",
      "qualified": "مؤهَّل",
      "active": "مؤهَّل ونشط",
      "rejected": "مرفوض",
      "suspended": "تأهيل معلَّق"
    },
    "qualifiedUntil": "مؤهَّل حتى {{date}}",
    "defaultCurrency": "العملة الافتراضية",
    "portalAccounts": "حسابات البوابة",
    "openRecord": "فتح سجل المورّد",
    "edit": "تعديل المورّد",
    "quickView": "عرض سريع",
    "procurableNow": "نعم",
    "procurableNowSentence": "يمكن الشراء من هذا المورّد الآن.",
    "cannotBuyTitle": "لا يمكن الشراء منه بعد",
    "cannotBuyNext": "يُبتّ في حالة التعامل وفي التأهيل من سجل المورّد.",
    "suspensionReason": "سبب الإيقاف",
    "emptyFiltered": "لا يوجد موردون مطابقون لهذه التصفية",
    "emptyFilteredHint": "غيّر التصفية أو امسحها لعرض موردين آخرين.",
    "emptyHint": "أضف مورّداً أو استورد قائمة الموردين.",
    "crHint": "10 أرقام",
    "vatHint": "15 رقماً، أوله وآخره الرقم 3",
    "crShort": "السجل التجاري",
    "identity": "الهوية والشروط"
  },
  "qualification": {
    "title": "التأهيل",
    "start": "بدء التأهيل",
    "submit": "إرسال للمراجعة",
    "approve": "اعتماد",
    "activate": "تفعيل التأهيل",
    "reject": "رفض",
    "suspend": "إيقاف",
    "validUntil": "صالح حتى",
    "decidedBy": "القرار بواسطة",
    "decisionReason": "سبب القرار",
    "checks": "عناصر الفحص",
    "none": "لم يبدأ التأهيل بعد",
    "history": "سجل التأهيل",
    "reasonRequired": "السبب مطلوب لهذا القرار.",
    "notDecided": "لم يُبتّ فيه"
  },
  "agreement": {
    "title": "الاتفاقيات الإطارية",
    "subtitle": "الشروط التجارية المتفق عليها مع الموردين",
    "reference": "المرجع",
    "validFrom": "سارية من",
    "validTo": "سارية حتى",
    "currency": "العملة",
    "usableNow": "سارية الآن",
    "dueForRenewal": "قريبة الانتهاء",
    "create": "إضافة اتفاقية",
    "empty": "لا توجد اتفاقيات",
    "activate": "تفعيل",
    "suspend": "إيقاف",
    "terminate": "إنهاء",
    "items": "البنود المسعّرة",
    "addItem": "إضافة بند",
    "reprice": "تعديل السعر",
    "unitPrice": "سعر الوحدة",
    "supplierSku": "رمز المورد",
    "moq": "أقل كمية للطلب",
    "revision": "المراجعة",
    "superseded": "مستبدل",
    "version": "الإصدار",
    "repriceNotice": "تعديل السعر ينشئ مراجعة جديدة ويحتفظ بالسعر السابق للطلبات القائمة.",
    "expiring": "تقترب من الانتهاء",
    "terminateNotice": "الإنهاء يوقف هذه الاتفاقية نهائياً. كل ما تُسعّره يتوقف عن كونه قابلاً للطلب، ولا يمكن إعادة تفعيلها.",
    "createNotice": "تُنشأ الاتفاقية كمسودة. الاتفاق على الشروط لا يجعلها قابلة للطلب — لا بد أن يفعّلها صاحب صلاحية الاتفاقيات.",
    "edit": "تعديل الشروط",
    "editNotice": "المورد والعملة يُثبّتان عند الإنشاء. تغيير المورد يعيد كتابة الطرف المتعاقد معه، وتغيير العملة يعيد تفسير كل سعر تم الاتفاق عليه.",
    "currencyFixedNotice": "لا يمكن تغيير العملة بعد إنشاء الاتفاقية.",
    "currentPrice": "السعر الحالي",
    "newPrice": "السعر الجديد",
    "effectiveFrom": "ساري من",
    "paymentTerms": "شروط الدفع",
    "noneConsequence": "بدون اتفاقية سارية لا يمكن طلب أي شيء من هذا المورد.",
    "single": "الاتفاقية",
    "validity": "السريان",
    "coverage": "تنطبق على",
    "coverageAll": "كل وحدات الشراء",
    "coverageSelected": "وحدات شراء محددة",
    "itemCount": "البنود",
    "usableOnly": "القابلة للاستخدام اليوم فقط",
    "dueOnly": "المستحقة للتجديد فقط",
    "emptyHint": "تُنشأ الاتفاقيات من صفحة المورد الذي تُبرم معه.",
    "notUsableTitle": "لا يمكن الطلب بموجب هذه الاتفاقية اليوم",
    "terms": "الشروط",
    "renewalNotice": "مهلة التنبيه للتجديد",
    "renewalNoticeDays_zero": "يوم انتهائها",
    "renewalNoticeDays_one": "قبل انتهائها بيوم واحد",
    "renewalNoticeDays_two": "قبل انتهائها بيومين",
    "renewalNoticeDays_few": "قبل انتهائها بـ {{count}} أيام",
    "renewalNoticeDays_many": "قبل انتهائها بـ {{count}} يوماً",
    "renewalNoticeDays_other": "قبل انتهائها بـ {{count}} يوم",
    "lineCount": "البنود: {{count}}",
    "showEarlier": "إظهار الأسعار السابقة",
    "noItems": "لا توجد بنود مسعّرة بعد",
    "item": "الصنف",
    "lineTerms": "الشروط",
    "effective": "السريان",
    "asAgreement": "حسب الاتفاقية",
    "fromDate": "من {{date}}",
    "untilDate": "حتى {{date}}",
    "validityNotSet": "غير محدد — مطلوب قبل التفعيل",
    "validToNotSet": "لم يُحدَّد تاريخ الانتهاء",
    "coverageNone": "لا توجد وحدة شراء بعد — مطلوبة قبل التفعيل",
    "origin": "أُنشئت من",
    "originAward": "ترسية",
    "activateTitle": "تفعيل هذه الاتفاقية؟",
    "activateConfirm": "تفعيل الاتفاقية",
    "activateNotice": "بعد التفعيل يمكن طلب بنودها المسعّرة في وحدات الشراء التي تنطبق عليها حتى تاريخ انتهائها.",
    "activateAwardNotice": "جاءت من ترسية: وتفعيلها يجعل أصناف الكتالوج التي أعدّتها الترسية قابلة للطلب أيضاً.",
    "blocker": {
      "validity_missing": "حدّد تاريخ الانتهاء من «تعديل الشروط» قبل التفعيل.",
      "validity_ended": "انقضى تاريخ الانتهاء. حدّد تاريخ انتهاء لاحقاً من «تعديل الشروط» قبل التفعيل.",
      "coverage_missing": "اختر وحدات الشراء من «تعديل الشروط» قبل التفعيل."
    },
    "coverageSection": "أين تنطبق",
    "coverageSectionHint": "وحدات الشراء التي يمكن تسعير طلباتها بهذه الاتفاقية.",
    "coverageRestrict": "وحدات الشراء المختارة أدناه فقط",
    "coverageUnits": "وحدات الشراء",
    "coverageRestrictedToNone": "لا يمكن تفعيل اتفاقية مقيّدة بلا وحدة شراء.",
    "new": "اتفاقية جديدة",
    "chooseSupplier": "مع أيّ مورد هذه الاتفاقية؟",
    "chooseSupplierHint": "تُعقد الاتفاقية مع مورد واحد، ولا يُعرض الموردون المؤرشفون."
  },
  "catalogue": {
    "title": "الكتالوج",
    "subtitle": "الأصناف المعتمدة المتاحة لوحدة الشراء الخاصة بك",
    "search": "ابحث بالعربية أو الإنجليزية",
    "price": "السعر المتعاقد عليه",
    "taxRate": "نسبة الضريبة",
    "source": "مصدر التوريد",
    "supplierSource": "مورد خارجي",
    "warehouseSource": "مستودع داخلي",
    "orderable": "متاح للطلب",
    "notOrderable": "غير متاح حالياً",
    "whyNot": "سبب عدم الإتاحة",
    "empty": "لا توجد أصناف مطابقة",
    "allCategories": "كل الفئات",
    "allSuppliers": "كل الموردين",
    "priceControlled": "السعر محدد باتفاقية معتمدة ولا يمكن تعديله.",
    "leadTime": "مدة التوريد",
    "moq": "أقل كمية للطلب",
    "admin": "إدارة الكتالوج",
    "createItem": "إضافة صنف",
    "addSource": "إضافة مصدر",
    "branchAccess": "صلاحية وحدات الشراء",
    "item": "الصنف",
    "code": "الرمز",
    "unitOfMeasure": "وحدة القياس",
    "packSize": "حجم العبوة",
    "perUnit": "لكل {{unit}}",
    "warehouseNoPrice": "يُورَّد من مستودع الشركة — لا ينطبق سعر مورد.",
    "leadTimeDays": "مدة التوريد (بالأيام)",
    "offCatalogueTitle": "لم تجد ما تحتاجه؟",
    "offCatalogueHint": "صِف ما تحتاجه وستتولى المشتريات توفيره — لا تختار المورد ولا السعر.",
    "offCatalogueAction": "اطلب صنفاً من خارج الكتالوج",
    "description": "الوصف",
    "sources": "من أين يأتي",
    "sourcesHint": "كل مصادر هذا الصنف، وهل يمكن استخدامها الآن.",
    "agreedPriceForNode": "السعر المتفق عليه لوحدة الشراء الخاصة بك، للوحدة",
    "orderingUnit": "وحدة الطلب",
    "suppliedBy": "يورّده",
    "currentRequest": "سلتك",
    "linesInRequest": "عدد البنود فيها: {{count}}"
  },
  "unusable": {
    "item_inactive": "الصنف غير نشط",
    "source_inactive": "مصدر التوريد غير نشط",
    "supplier_not_active": "المورد غير نشط",
    "supplier_not_qualified": "المورد غير مؤهل",
    "agreement_missing": "لا توجد اتفاقية",
    "agreement_not_active": "الاتفاقية غير نشطة",
    "agreement_not_started": "الاتفاقية لم تبدأ بعد",
    "agreement_expired": "الاتفاقية منتهية",
    "price_missing": "لا يوجد سعر متعاقد",
    "price_not_yet_effective": "السعر لم يسرِ بعد",
    "price_expired": "السعر منتهي",
    "agreement_item_inactive": "بند الاتفاقية غير نشط",
    "currency_not_enabled": "العملة غير مفعّلة",
    "tax_code_unusable": "رمز الضريبة غير صالح",
    "branch_not_permitted": "غير متاح لوحدة الشراء هذه",
    "warehouse_not_active": "المستودع غير نشط",
    "warehouse_does_not_serve_branch": "المستودع لا يخدم وحدة الشراء هذه",
    "currency_mismatch": "مسعّر بعملة أخرى"
  },
  "budget": {
    "title": "الميزانيات",
    "subtitle": "الرقابة التشغيلية على الإنفاق حسب وحدة الشراء والفئة والفترة",
    "period": "الفترة",
    "branchAll": "كل وحدات الشراء",
    "categoryAll": "كل الفئات",
    "allocated": "المخصص",
    "requested": "المطلوب",
    "reserved": "المحجوز",
    "committed": "الملتزم به",
    "received": "المستلم",
    "invoiced": "المفوتر",
    "available": "المتاح",
    "utilisation": "نسبة الاستهلاك",
    "create": "إضافة ميزانية",
    "empty": "لا توجد ميزانيات",
    "allocate": "تخصيص مبلغ",
    "allocateHint": "استخدم قيمة سالبة للتخفيض، ويلزم حينها ذكر السبب.",
    "ledger": "دفتر الحركات",
    "ledgerSubtitle": "كل حركة أثّرت على هذه الميزانية — الدفتر هو المرجع",
    "movementType": "نوع الحركة",
    "bucket": "البند",
    "amount": "المبلغ",
    "balanceAfter": "الرصيد بعد",
    "noMovements": "لا توجد حركات بعد",
    "reconcile": "مطابقة مع الدفتر",
    "consistent": "الأرقام مطابقة للدفتر",
    "softControl": "الرقابة على الميزانية تنبيهية: التجاوز لا يمنع الطلب بل يغيّر مسار اعتماده.",
    "createPeriod": "إضافة فترة",
    "startsOn": "تبدأ في",
    "endsOn": "تنتهي في",
    "periodOrder": "لا يمكن أن يسبق تاريخ الانتهاء تاريخ البدء.",
    "changeStatus": "تغيير الحالة",
    "activeNotice": "تستقبل الميزانية إنفاقاً جديداً ويمكن تخصيص مبالغ لها.",
    "frozenNotice": "التخصيص مثبّت. لا يمكن تحميل أي إنفاق جديد عليها، وما التُزم به سابقاً يُستكمل.",
    "closedNotice": "ترفض الميزانية كل شيء: لا إنفاق جديد ولا حجز ولا تخصيص إضافي.",
    "reduce": "خفض التخصيص",
    "budgetColumn": "الميزانية",
    "emptyHint": "الميزانيات اختيارية. من دونها يحمل الطلب حالة «لا ميزانية» التي يمكن لقواعد الاعتماد التوجيه بناءً عليها.",
    "informational": "المطلوب والمستلم والمفوتر للعلم فقط وليست جزءاً من المعادلة: المتاح = المخصص − المحجوز − الملتزم به.",
    "adjustAllocation": "تعديل التخصيص",
    "openLedger": "فتح السجل",
    "reductionReason": "يتطلب تخفيض التخصيص ذكر السبب.",
    "movementSequence": "عدد الحركات: {{count}}",
    "movements": "الحركات",
    "reasonLine": "السبب: {{reason}}",
    "group": "المجموعة",
    "source": "المصدر",
    "sourceRequest": "طلب",
    "sourceOrder": "أمر شراء",
    "by": "بواسطة",
    "appendOnly": "السجل للإضافة فقط. يُصحَّح الخطأ بحركة إضافية، لا بالتعديل.",
    "driftFound": "لم تطابق الأرقام السجل",
    "driftExplained": "أُعيد بناؤها من السجل وسُجّل التصحيح. ما الذي تغيّر:",
    "allocatedAfter": "المخصص بعد الحركة",
    "afterIsPreview": "معاينة إلى أن يسجّلها سجل الميزانية."
  },
  "approvalRule": {
    "title": "قواعد الاعتماد",
    "subtitle": "مرتّبة كما يفحصها النظام. مستويان بشريان للاعتماد كحد أقصى.",
    "create": "إضافة قاعدة",
    "empty": "لا توجد قواعد",
    "priority": "الأولوية",
    "approvalType": "نوع الاعتماد",
    "when": "عندما",
    "then": "عندئذٍ",
    "next": "ثم",
    "level": "المستوى",
    "addCondition": "إضافة شرط",
    "addStep": "إضافة مستوى",
    "stopsProcessing": "إيقاف تقييم القواعد التالية",
    "active": "نشطة",
    "effectiveFrom": "سارية من",
    "effectiveTo": "سارية حتى",
    "version": "الإصدار",
    "precedence": "عند تطابق أكثر من قاعدة: الأولوية الأقل تفوز، ثم الأكثر تحديداً.",
    "noConditions": "تنطبق على كل الطلبات",
    "field": "الحقل",
    "operator": "المقارنة",
    "value": "القيمة",
    "approver": "المعتمد",
    "role": "الدور",
    "slaHours": "مهلة الاستجابة (ساعات)",
    "coverageComplete_zero": "كل وحدات الشراء لديها معتمد مؤهل لكل مستوى في هذه القاعدة (لا وحدات شراء).",
    "coverageComplete_one": "كل وحدات الشراء لديها معتمد مؤهل لكل مستوى في هذه القاعدة (وحدة واحدة).",
    "coverageComplete_two": "كل وحدات الشراء لديها معتمد مؤهل لكل مستوى في هذه القاعدة (وحدتان).",
    "coverageComplete_few": "كل وحدات الشراء لديها معتمد مؤهل لكل مستوى في هذه القاعدة ({{count}} وحدات).",
    "coverageComplete_many": "كل وحدات الشراء لديها معتمد مؤهل لكل مستوى في هذه القاعدة ({{count}} وحدة).",
    "coverageComplete_other": "كل وحدات الشراء لديها معتمد مؤهل لكل مستوى في هذه القاعدة ({{count}} وحدة).",
    "coverageGap_zero": "لا توجد وحدة شراء بلا معتمد مؤهل لهذه القاعدة.",
    "coverageGap_one": "وحدة شراء واحدة بلا معتمد مؤهل لهذه القاعدة.",
    "coverageGap_two": "وحدتا شراء بلا معتمد مؤهل لهذه القاعدة.",
    "coverageGap_few": "{{count}} وحدات شراء بلا معتمد مؤهل لهذه القاعدة.",
    "coverageGap_many": "{{count}} وحدة شراء بلا معتمد مؤهل لهذه القاعدة.",
    "coverageGap_other": "{{count}} وحدة شراء بلا معتمد مؤهل لهذه القاعدة.",
    "coverageConsequence": "ستُرفض طلبات وحدات الشراء هذه عند الإرسال حتى يُعيَّن معتمد — لا يُنفَّذ المسار بعدد مستويات أقل مما هو مهيأ.",
    "coverageGapNotDistinct_zero": "لا توجد وحدة شراء لديها شخص مؤهل واحد فقط لأكثر من مستوى في هذه القاعدة.",
    "coverageGapNotDistinct_one": "وحدة شراء واحدة لديها شخص مؤهل واحد فقط لأكثر من مستوى في هذه القاعدة.",
    "coverageGapNotDistinct_two": "وحدتا شراء لديهما شخص مؤهل واحد فقط لأكثر من مستوى في هذه القاعدة.",
    "coverageGapNotDistinct_few": "{{count}} وحدات شراء لديها شخص مؤهل واحد فقط لأكثر من مستوى في هذه القاعدة.",
    "coverageGapNotDistinct_many": "{{count}} وحدة شراء لديها شخص مؤهل واحد فقط لأكثر من مستوى في هذه القاعدة.",
    "coverageGapNotDistinct_other": "{{count}} وحدة شراء لديها شخص مؤهل واحد فقط لأكثر من مستوى في هذه القاعدة.",
    "coverageConsequenceNotDistinct": "المستويان يحتاجان شخصين. لا يمكن للشخص نفسه أن يوقّع مرتين، لذا ستُرفض هذه الطلبات عند المستوى الثاني حتى يُعيَّن معتمد آخر.",
    "coverageLevel": "المستوى {{level}} ({{approver}})",
    "coverage": "تغطية المعتمدين",
    "deleteNotice": "تُحذف القاعدة من السياسة. ستُوجَّه الطلبات وفق القاعدة التالية المطابقة، وقد يكون المسار مختلفاً.",
    "deleteKeepsHistory": "الاعتمادات التي صدرت لا تتأثر — يحتفظ كل مسار بنسخته من القاعدة التي وجّهته.",
    "testRequest": "اختبار طلب",
    "listTitle": "القواعد بترتيب التقييم",
    "listSubtitle": "يُفحص رقم الأولوية الأصغر أولاً",
    "emptyHint": "إلى أن تُضاف قاعدة، يسلك كل طلب المسار الاحتياطي المحدد في الإعدادات.",
    "stops": "يتوقف التقييم هنا",
    "continues": "يستمر التقييم",
    "rule": "القاعدة",
    "route": "المسار",
    "versionShort": "الإصدار {{version}}",
    "inForce": "سارية",
    "notInForce": "غير سارية",
    "deactivated": "معطّلة",
    "fromDate": "من {{date}}",
    "untilDate": "حتى {{date}}",
    "edit": "تعديل القاعدة",
    "appliesTitle": "تُطبَّق التغييرات عند التقديم التالي",
    "appliesBody": "يحتفظ الطلب الموجود في مسار الاعتماد بالمسار الذي قُدِّم به.",
    "howTitle": "كيف تُطبَّق القواعد",
    "maxLevels": "للمسار مستويان بشريان متتاليان كحد أقصى، ولا يعمل بأقل مما هو مهيأ به.",
    "noMatch": "إذا لم تطابق أي قاعدة، يُطبَّق المسار الاحتياطي المحدد في الإعدادات.",
    "summaryTitle": "السياسة باختصار",
    "lastChanged": "آخر تعديل",
    "deleteRule": "حذف القاعدة",
    "and": "و",
    "valueMissing": "سجل لم يعد موجوداً",
    "noHuman": "لا يلزم اعتماد بشري",
    "levelShort": "المستوى {{level}}",
    "approverMissing": "لم يُحدَّد معتمِد",
    "slaShort": "{{hours}} ساعة",
    "behaviourTitle": "سلوك الاعتماد",
    "behaviourSubtitle": "إعدادات منشأتك — تُطبَّق إلى جانب القواعد",
    "changeInSettings": "التعديل من الإعدادات",
    "settingOn": "مفعّل",
    "settingOff": "غير مفعّل",
    "newTitle": "قاعدة اعتماد جديدة",
    "newSubtitle": "تحدد القاعدة مسار الاعتماد للطلبات التي تطابقها.",
    "backToRules": "قواعد الاعتماد",
    "effectiveHint": "اتركه فارغاً ليُطبَّق من الآن دون تاريخ انتهاء.",
    "whenTitle": "عندما يطابق الطلب",
    "whenHint": "يجب أن يتحقق كل شرط. القاعدة بلا شروط تنطبق على كل الطلبات.",
    "thenTitle": "ثم يُوجَّه إلى",
    "removeCondition": "إزالة الشرط",
    "values": "القيم",
    "chooseOne": "اختر…",
    "valueMissingFix": "تشير هذه القيمة إلى سجل لم يعد موجوداً. اختر قيمة أخرى أو احذف الشرط.",
    "valueFrom": "من",
    "valueTo": "إلى",
    "humanLevels": "المستويات البشرية: {{count}}",
    "approverType": "نوع المعتمِد",
    "person": "الشخص",
    "personKept": "لا يمكنك عرض قائمة الأشخاص هنا؛ يبقى الشخص المحفوظ لهذا المستوى ما لم تغيّر نوع المعتمِد.",
    "previewTitle": "معاينة المسار",
    "previewHint": "ما ستفعله هذه القاعدة بعد حفظها. اختبر طلباً لمعرفة القاعدة التي تسود.",
    "saveRule": "حفظ القاعدة",
    "savingCreatesVersion": "يُنشئ الحفظ الإصدار {{version}}. تحتفظ الطلبات الموجودة في مسار الاعتماد بالمسار الذي قُدِّمت به.",
    "savingCreatesRule": "يضيف الحفظ القاعدة حسب أولويتها. تحتفظ الطلبات الموجودة في مسار الاعتماد بالمسار الذي قُدِّمت به.",
    "notSaved": "لم تُحفظ القاعدة",
    "fixFields": "كل مشكلة أدناه تنقلك إلى حقلها:",
    "codeHint": "أحرف وأرقام و - و _ فقط",
    "priorityHint": "رقم صحيح من 1 إلى 9999. يُفحص الرقم الأصغر أولاً.",
    "slaHint": "اختياري. يُعدّ القرار بعد هذه المدة متأخراً.",
    "conditionN": "الشرط {{n}}",
    "inCurrency": "بعملة {{currency}}",
    "appliesWhen": "ينطبق عندما"
  },
  "simulator": {
    "title": "محاكاة قاعدة الاعتماد",
    "subtitle": "جرّب سياقاً افتراضياً قبل حفظ التغييرات",
    "run": "تشغيل المحاكاة",
    "amount": "المبلغ",
    "branch": "وحدة الشراء",
    "category": "الفئة",
    "budgetStatus": "حالة الميزانية",
    "result": "النتيجة",
    "matchedRule": "القاعدة المطابقة",
    "levels": "مستويات الاعتماد",
    "reasons": "الأسباب",
    "allMatches": "كل القواعد المطابقة",
    "noHumanApproval": "لا يتطلب اعتماداً بشرياً",
    "sameEngine": "تستخدم المحاكاة نفس محرك الاعتماد المستخدم فعلياً."
  },
  "request": {
    "title": "طلبات الشراء",
    "subtitle": "طلباتك ومسارها",
    "cart": "السلة",
    "cartSubtitle": "سلة واحدة قد تضم عدة موردين",
    "number": "رقم الطلب",
    "requester": "مقدم الطلب",
    "requiredBy": "مطلوب بحلول",
    "businessReason": "مبرر الطلب",
    "notes": "ملاحظات",
    "submit": "إرسال الطلب",
    "cancel": "إلغاء الطلب",
    "empty": "لا توجد طلبات بعد.",
    "emptyDescription": "ستظهر هنا الطلبات التي تنشئها أو يمكنك الاطلاع عليها.",
    "emptyFiltered": "لا توجد طلبات مطابقة لاختياراتك.",
    "emptyFilteredDescription": "جرّب تغيير التصفية أو مسحها.",
    "filterTitle": "تصفية الطلبات",
    "showRequests": "عرض الطلبات",
    "purchasingNodeHelp": "الموقع أو القسم أو موقع العمل الذي صدر منه الطلب.",
    "collection": {
      "all": "كل الطلبات",
      "mine": "طلباتي"
    },
    "emptyCart": "السلة فارغة",
    "addFromCatalogue": "أضف من الكتالوج",
    "remove": "إزالة",
    "quantity": "الكمية",
    "unitPrice": "سعر الوحدة",
    "lineTotal": "إجمالي البند شاملًا الضريبة",
    "total": "الإجمالي",
    "subtotal": "المجموع قبل الضريبة",
    "tax": "الضريبة",
    "budgetImpact": "الأثر على الميزانية",
    "expectedApproval": "مسار الاعتماد المتوقع",
    "noApprovalNeeded": "لا يتطلب اعتماداً بشرياً",
    "timeline": "سجل الطلب",
    "nextStep": "الخطوة التالية",
    "items": "الأصناف",
    "approvedQuantity": "الكمية المعتمدة",
    "priceControlled": "السعر والمورد يحددهما المقر الرئيسي ولا يمكن تعديلهما.",
    "submitBlocked": "لا يمكن إرسال الطلب بصيغته الحالية.",
    "resubmit": "إعادة الإرسال",
    "offCatalogue": "طلب صنف خارج الكتالوج",
    "offCatalogueSubtitle": "صف احتياجك وسيتولى قسم المشتريات تحديد المورد والسعر",
    "itemName": "اسم الصنف المطلوب",
    "specification": "المواصفات",
    "category": "الفئة",
    "unit": "الوحدة",
    "offCatalogueNotice": "لا يمكنك تحديد مورد أو سعر — يتولى قسم المشتريات ذلك عبر عملية التوريد المعتمدة.",
    "submissionCount": "عدد مرات الإرسال",
    "created": "أُنشئ",
    "amendSubtitle": "عدّل الطلب المُعاد ثم أعد إرساله للاعتماد",
    "amend": "تعديل الطلب",
    "reorder": "إعادة الطلب",
    "reorderPartial": "تعذّرت إضافة بعض البنود إلى سلتك:",
    "reorderReason": {
      "no_usable_source": "لم يعد متاحًا بسعر معتمد",
      "catalogue_item_removed": "لم يعد ضمن الكتالوج",
      "NOT_FOUND": "لم يعد متاحًا لوحدة الشراء الخاصة بك",
      "VALIDATION_FAILED": "لا يمكن طلبه بعملة هذا الطلب",
      "ENTITY_INACTIVE": "لم يعد نشطًا"
    },
    "addToRequest": "أضف إلى السلة",
    "addedToCart": "أُضيف إلى سلتك",
    "openCart": "افتح السلة",
    "itemUnnamed": "صنف",
    "priceNotResolved": "يُؤكَّد السعر عند فحص السلة.",
    "purchaseRequest": "طلب الشراء",
    "noReason": "لم يُذكر سبب",
    "lineCount": "البنود: {{count}}",
    "showCount": "عرض الطلبات ({{count}})",
    "noLines": "لا توجد بنود في هذا الطلب.",
    "itemsSubtitle": "عدد البنود: {{count}} · {{total}}",
    "details": "التفاصيل",
    "detailsRail": "تفاصيل الطلب وسجله",
    "submittedBy": "قُدِّم في {{date}} بواسطة {{name}}",
    "notSubmitted": "لم يُقدَّم بعد",
    "recordViews": "سجل الطلب",
    "approvalTab": "مسار الاعتماد",
    "whyThisRoute": "سبب هذا المسار",
    "noApprovalYet": "يُحدَّد مسار الاعتماد عند تقديم الطلب.",
    "noBudgetImpact": "لا يوجد أثر مسجّل على الميزانية لهذا الطلب.",
    "sourcingOutcome": {
      "title": "اكتمل التوريد",
      "subtitle": "تمت ترسية طلب عرض السعر لهذا الاحتياج، وأصبح الآن لدى المشتريات.",
      "enquiry": "طلب عرض السعر",
      "agreement": "الاتفاقية الإطارية",
      "agreementStatus": "حالة الاتفاقية",
      "validTo": "سارية حتى",
      "coverage": "تنطبق على",
      "coverageAll": "كل وحدات الشراء",
      "items": "أصناف الكتالوج",
      "notBuyable": "لا يمكن الشراء قبل أن تفعّل المشتريات الاتفاقية.",
      "noReservation": "لا يوجد حجز نهائي للميزانية بعد: ليس للاحتياج سعر متفق عليه. وتُراجَع الميزانية والسياسات مجدداً قبل أي التزام.",
      "reservationHeld": "تبقى الميزانية المحجوزة لهذا الطلب محجوزة حتى يلتزم بها أمر شراء أو يُفرج عنها."
    },
    "approvers": "المعتمِدون",
    "levelN": "المستوى {{level}}",
    "withApprover": "لدى هذا المعتمِد",
    "nextLevel": "التالي",
    "availableBefore": "المتاح قبل هذا الطلب",
    "thisRequest": "هذا الطلب",
    "availableAfter": "المتاح بعد هذا الطلب",
    "openRecord": "فتح الطلب",
    "budgetAfter": "المتاح بعد هذا الطلب: {{amount}}",
    "viewBudget": "عرض الأثر على الميزانية",
    "notSent": "لم يُرسَل الطلب",
    "itemNameHint": "صِف الصنف أو الخدمة بكلمات بسيطة — ستجد المشتريات المصدر المناسب.",
    "businessReasonHint": "لماذا تحتاجه — تقرؤه المشتريات قبل أن تقرر كيف توفّره.",
    "specificationHint": "المقاس أو المادة أو اللون أو الأداء أو تفاصيل التركيب التي تساعد المشتريات على توفير الشيء الصحيح.",
    "noSupplierOrPrice": "لا حاجة إلى مورد أو سعر",
    "whatHappensNext": "ما الذي يحدث بعد ذلك",
    "offCatalogueNext1": "تراجع المشتريات احتياجك.",
    "offCatalogueNext2": "إن لزم توفيره، تطلب المشتريات عروض أسعار من موردين مؤهلين.",
    "offCatalogueNext3": "تتابع كل خطوة في صفحة الطلب نفسه.",
    "offCatalogueSendNote": "ستراجع المشتريات هذا الاحتياج وتقرر الخطوة المنضبطة التالية.",
    "sendToProcurement": "إرسال إلى المشتريات",
    "offCatalogueNotAllowed": "لا يتيح دورك طلب صنف من خارج الكتالوج. إن احتجت إليه فتواصل مع قسم المشتريات.",
    "reviewAction": "مراجعة وإرسال",
    "review": "المراجعة والإرسال",
    "reviewSubtitle": "راجع التفاصيل وضوابط الشراء قبل الإرسال.",
    "summary": "الملخص",
    "budgetNotReservedYet": "لم يُحجز شيء بعد — تُحجز الميزانية عند الإرسال فقط.",
    "buyingControls": "ضوابط الشراء",
    "checkedAgain": "تُفحص مجدداً عند الإرسال.",
    "approvalLevel": "اعتماد المستوى {{number}}",
    "submitExplains": "عند الإرسال تُفحص هذه الضوابط مجدداً وتُحجز الميزانية."
  },
  "approvals": {
    "title": "الاعتمادات",
    "subtitle": "الطلبات التي تنتظر قرارك",
    "empty": "لا توجد طلبات بانتظارك",
    "amount": "المبلغ",
    "budgetStatus": "حالة الميزانية",
    "exceptions": "الاستثناءات",
    "whyRouted": "سبب التوجيه",
    "dueAt": "موعد الاستجابة",
    "overdue": "متأخر",
    "level": "المستوى",
    "approve": "اعتماد",
    "reject": "رفض",
    "return": "إعادة للتعديل",
    "partialApprove": "اعتماد جزئي",
    "decisionReason": "سبب القرار",
    "reasonRequired": "السبب مطلوب لهذا القرار.",
    "approvedQuantity": "الكمية المعتمدة",
    "requestedQuantity": "الكمية المطلوبة",
    "decide": "اتخاذ القرار",
    "escalatedTo": "تم التصعيد إلى {{name}}",
    "history": "سجل الاعتماد",
    "decidedBy": "بواسطة {{name}}",
    "onBehalfOf": "نيابةً عن {{name}}",
    "waitingForLevel": "بانتظار المستوى {{level}}",
    "laterLevel": "المستوى {{level}}، بعد ذلك",
    "approvedAmount": "المبلغ المعتمد"
  },
  "order": {
    "title": "أوامر الشراء",
    "subtitle": "كل الأوامر وما وصل إليه كل منها",
    "empty": "لا توجد أوامر شراء",
    "number": "رقم الأمر",
    "draftOrder": "أمر مسودة",
    "draftOrderFor": "أمر مسودة · {{supplier}}",
    "draftReference": "المرجع",
    "draftNumberNote": "يُعطى رقم الأمر عند إصداره.",
    "copyReference": "نسخ المرجع",
    "referenceCopied": "نُسخ المرجع",
    "lifecycle": "الأمر",
    "vendorResponse": "المورد",
    "fulfilment": "التسليم",
    "invoicing": "الفوترة",
    "issue": "إصدار الأمر",
    "send": "إرسال للمورد",
    "resend": "إعادة الإرسال",
    "amend": "تعديل الأمر",
    "cancel": "إلغاء الأمر",
    "document": "المستند",
    "versions": "الإصدارات",
    "version": "إصدار",
    "material": "تغيير جوهري",
    "activity": "ما أُرسل وما ورد",
    "committed": "الملتزم به",
    "fromRequest": "من الطلب",
    "acknowledgementStale": "أكّد المورد الإصدار {{acknowledged}}. الأمر الآن في الإصدار {{current}} ويحتاج تأكيداً جديداً.",
    "expectedDelivery": "تاريخ التسليم من المورد",
    "expectedDeliveryNone": "لم يُحدَّد بعد",
    "expectedDeliveryLate": "بعد التاريخ المطلوب",
    "requestedBy": "التسليم المطلوب بحلول",
    "dispatches": "الشحنات المُرسلة",
    "noDispatches": "لم تُشحن أي كمية بعد",
    "deliveryNote": "إشعار التسليم",
    "dispatchedAt": "تاريخ الشحن",
    "availability": "ما يستطيع المورد توفيره",
    "ordered": "المطلوب",
    "available": "المتوفر",
    "unavailable": "النقص",
    "procurementRecord": "سجل الشراء",
    "recordComplete": "مكتمل",
    "recordActive": "جارٍ",
    "generate": "إنشاء أوامر الشراء",
    "generateHint": "يُنشأ أمر شراء واحد لكل مورد خارجي في هذا الطلب. البنود التي مصدرها مستودع الشركة تُلبّى داخلياً ولا تُطلب من مورد.",
    "generateDone": "أوامر الشراء جاهزة.",
    "generateReplay": "هذه الأوامر موجودة مسبقاً. لم يُنشأ شيء مرة ثانية.",
    "generatedOrders": "الأوامر المُنشأة",
    "internalTransferLines": "تُلبّى داخلياً",
    "internalTransferHint": "مصدرها مستودع الشركة، لذلك لم يُنشأ أمر شراء لمورد.",
    "blockedSuppliers": "موردون تعذّر الطلب منهم",
    "unsourcedLines": "بنود بلا مصدر صالح",
    "tracking": "المتابعة",
    "issuedOn": "صدر في {{date}}",
    "field": {
      "heading": "الحقل",
      "required_by": "التسليم المطلوب بحلول",
      "notes": "الملاحظات",
      "lifecycle_status": "حالة الأمر",
      "quantity": "الكمية",
      "unit_of_measure": "الوحدة",
      "specification": "المواصفات",
      "unit_price": "سعر الوحدة",
      "tax_rate": "نسبة الضريبة",
      "line_subtotal": "المجموع الفرعي للبند",
      "line_tax": "ضريبة البند",
      "line_total": "إجمالي البند",
      "order_subtotal": "المجموع الفرعي للأمر",
      "order_tax": "ضريبة الأمر",
      "order_total": "قيمة الأمر"
    },
    "lineChange": {
      "added": "بند أُضيف في هذا الإصدار",
      "removed": "بند حُذف في هذا الإصدار"
    },
    "noFieldChanged": "لم يتغيّر في هذا الإصدار أي حقل يحمله الأمر.",
    "differenceCaption": "ما تغيّر من الإصدار {{from}} إلى الإصدار {{to}}",
    "versionShort": "الإصدار {{version}}",
    "versionLabel": "الإصدار {{version}}",
    "receiptRef": "استلام {{reference}}",
    "receiptOn": "استلام بتاريخ {{date}}",
    "linesReceived": "استُلم {{received}} من {{lines}} بنود",
    "unitsReceived": "{{received}} من {{ordered}} {{unit}}",
    "noInvoices": "لا فاتورة مسجّلة",
    "cancelledOn": "أُلغي في {{date}} · الإصدار {{version}} نهائي",
    "versionIssued": "صدر الإصدار {{version}} في {{date}}",
    "versionIssuedSuperseded": "صدر الإصدار {{version}} في {{date}} · حلّ محل الإصدار {{previous}}",
    "ackCurrent": "أكّده المورد على الإصدار {{version}}",
    "ackOlderOnly": "أكّد المورد الإصدار {{version}} فقط",
    "ackAwaited": "بانتظار رد المورد على الإصدار {{version}}",
    "lastReceipt": "آخر استلام {{date}}",
    "attention": {
      "title": "يحتاج إلى متابعة",
      "query": "أرسل المورد استفساراً عن الإصدار {{version}}",
      "declined": "رفض المورد الإصدار {{version}}",
      "partial": "يستطيع المورد توفير جزء فقط من الإصدار {{version}}",
      "lateDetail": "تاريخ المورد {{promised}}؛ والمطلوب بحلول {{required}}."
    },
    "amendConsequence": "ينشئ الإصدار {{next}}. ويبقى الإصدار {{current}} محفوظاً.",
    "cancelConsequence": "يحرّر الالتزام المتبقي غير المستلم فقط.",
    "cancelConsequenceReceived": "استُلمت بضائع: ما وصل يبقى ملتزماً به، ولا يعود إلى الميزانية إلا الباقي.",
    "cancelConsequenceDraft": "لم يصدر قط: لا تتحرك أي أموال.",
    "sendConsequence": "يرسل الإصدار {{version}} إلى جهة اتصال المورد.",
    "recordReceipt": "تسجيل استلام",
    "versionCurrent": "الإصدار {{version}} · الحالي",
    "versionFinal": "نهائي",
    "versionIsCurrent": "الحالي",
    "versionSuperseded": "محل محله إصدار أحدث",
    "linesTitle": "البنود",
    "item": "الصنف",
    "received": "المستلم",
    "remaining": "المتبقي",
    "messagesTitle": "الرسائل إلى المورد",
    "messagesSubtitle": "ما أُرسل بشأن هذا الأمر، وهل وصل.",
    "recordRail": "إجراءات الأمر وسجله",
    "actions": "الإجراءات",
    "moreActions": "إجراءات أخرى",
    "actionsFor": "إجراءات {{number}}",
    "actionsForDraft": "إجراءات أمر المسودة هذا",
    "versionHistory": "سجل الإصدارات",
    "versionHistorySubtitle": "كل إصدار صادر مستند ثابت لا يتغيّر. الإصدار الجديد لا يعيد كتابة القديم.",
    "noVersions": "لم يصدر بعد.",
    "changeType": {
      "issue": "إصدار",
      "amendment": "تعديل",
      "cancellation": "إلغاء"
    },
    "whatChanged": "ما الذي تغيّر",
    "viewDocument": "المستند — الإصدار {{version}}",
    "orderCard": "الأمر",
    "supplier": "المورد",
    "crNumber": "السجل التجاري",
    "purchasingNode": "وحدة الشراء",
    "deliverTo": "التسليم إلى",
    "orderDate": "تاريخ الأمر",
    "notIssuedYet": "لم يصدر بعد",
    "orderValue": "قيمة الأمر",
    "notes": "الملاحظات",
    "closureReason": "سبب الإغلاق",
    "supplierResponses": "ردود المورد",
    "supplierResponsesSubtitle": "ما أبلغنا به المورد، ومتى.",
    "noSupplierResponse": "لم يرد المورد بعد.",
    "dispatchRecorded": "سُجّل شحن",
    "receiptsTitle": "الاستلامات",
    "receiptsSubtitle": "يسجّلها المشتري. هي أدلة وليست حالة — وكل منها مرتبط بالإصدار الذي استُلم عليه.",
    "receipt": "الاستلام",
    "receivedOn": "التاريخ",
    "receivedBy": "استلمه",
    "receiptLines": "البنود المقبولة",
    "nothingAccepted": "لم يُقبل شيء",
    "againstVersion": "على الإصدار",
    "noReceipts": "لم يُستلم شيء بعد",
    "invoicesRecorded": "الفواتير المسجّلة: {{count}} · {{amount}}",
    "linesSubtitle": "عدد البنود: {{count}} · المطلوب والمستلم لكل بند. تُسجَّل الفواتير على الأمر كاملاً.",
    "versionCount": "عدد الإصدارات: {{count}}",
    "filterTitle": "تصفية أوامر الشراء",
    "filterResponse": "رد المورد",
    "supplierFilterHint": "الموردون في الأوامر التي يمكنك فتحها.",
    "showOrders": "عرض أوامر الشراء",
    "showCount": "عرض أوامر الشراء: {{count}}",
    "emptyFiltered": "لا يوجد أمر شراء يطابق هذه التصفية"
  },
  "vendor": {
    "home": {
      "nav": "الرئيسية",
      "title": "ما يحتاج إلى إجراء منك",
      "subtitle": "أوامرك وطلبات العروض لدى هذا المشتري، حسب ما يحتاجه كل منها.",
      "toAcknowledge": "أوامر بانتظار تأكيدك",
      "toAcknowledgeHint": "ينتظر المشتري تأكيدك للإصدار الحالي.",
      "toDispatch": "أوامر بانتظار الشحن",
      "toDispatchHint": "مؤكَّدة، ولم يُشحن منها شيء بعد.",
      "toInvoice": "أوامر بانتظار الفاتورة",
      "toInvoiceHint": "شُحنت البضاعة، ولا توجد فاتورة على الأمر بعد.",
      "enquiries": "طلبات عروض بانتظار عرض سعرك",
      "enquiriesHint": "مفتوحة لأسعارك حتى الموعد النهائي.",
      "withBuyer": "بانتظار المشتري",
      "withBuyerHint": "طرحت سؤالاً أو اعتذرت. يجيب المشتري أو يعدّل الأمر.",
      "empty": "لا شيء هنا الآن.",
      "more_zero": "عرض الكل",
      "more_one": "واحد آخر — عرض الكل",
      "more_two": "اثنان آخران — عرض الكل",
      "more_few": "{{count}} أخرى — عرض الكل",
      "more_many": "{{count}} أخرى — عرض الكل",
      "more_other": "{{count}} أخرى — عرض الكل",
      "requiredBy": "مطلوب بحلول {{date}}",
      "dispatchedOn": "شُحن {{date}}",
      "issuedOn": "صدر {{date}}",
      "deadline": "الموعد النهائي {{date}}",
      "quoteAction": "إرسال عرض السعر",
      "allClear": "لا شيء يحتاج إلى إجراء منك الآن. تظهر هنا الأوامر وطلبات العروض الجديدة حين يرسلها المشتري."
    },
    "orders": "الأوامر",
    "ordersSubtitle": "أوامر الشراء المرسلة إليك",
    "noOrders": "لا توجد أوامر بعد",
    "awaitingCount_zero": "لا توجد أوامر بانتظار تأكيدك",
    "awaitingCount_one": "أمر واحد بانتظار تأكيدك",
    "awaitingCount_two": "أمران بانتظار تأكيدك",
    "awaitingCount_few": "{{count}} أوامر بانتظار تأكيدك",
    "awaitingCount_many": "{{count}} أمراً بانتظار تأكيدك",
    "awaitingCount_other": "{{count}} أمر بانتظار تأكيدك",
    "acknowledge": "تأكيد الاستلام",
    "acknowledgeVersion": "تأكيد الإصدار {{version}}",
    "acknowledgedOn": "أُكِّد في {{date}} (الإصدار {{version}})",
    "reacknowledge": "تغيّر هذا الأمر بعد تأكيدك له. يرجى مراجعة الإصدار {{version}} وتأكيده من جديد.",
    "deliverTo": "جهة التسليم",
    "notes": "ملاحظات للمشتري",
    "signInTitle": "دخول المورد",
    "signInSubtitle": "سجّل الدخول لعرض الأوامر المرسلة إليك.",
    "buyer": "المشتري",
    "buyerHint": "رمز المنشأة الذي زوّدك به المشتري.",
    "respond": "الرد على هذا الأمر",
    "respondHint": "أكِّد الأمر، أو حدِّد تاريخ التسليم، أو أبلغ عن نقص، أو اطرح سؤالاً، أو ارفض.",
    "answerType": "ردُّك",
    "typeAcknowledged": "تأكيد الأمر",
    "typeQuery": "طرح سؤال",
    "typePartial": "الإبلاغ عن نقص",
    "typeDeclined": "رفض الأمر",
    "deliveryDate": "تاريخ التسليم المتوقع",
    "deliveryDateHint": "التاريخ الذي تتوقع التسليم فيه. ويبقى لدى المشتري التاريخ الذي طلبه.",
    "reason": "السبب",
    "reasonRequired": "يُرجى ذكر السبب — يحتاجه المشتري للتصرف.",
    "send": "إرسال الرد",
    "sent": "تم إرسال ردك إلى المشتري.",
    "availabilityHint": "حدِّد الكمية التي تستطيع توفيرها لكل بند. يمكنك الإبلاغ عن كمية أقل من المطلوب، لا أكثر.",
    "availableQuantity": "الكمية المتاحة لديك",
    "lineNote": "ملاحظة على هذا البند",
    "dispatch": "تسجيل شحنة",
    "dispatchHint": "أبلغ المشتري بخروج الشحنة، مع إشعار التسليم الخاص بها.",
    "deliveryNoteRef": "رقم إشعار التسليم",
    "deliveryNoteHint": "مرجعك الخاص لهذه الشحنة. إرساله مرتين يسجل شحنة واحدة لا اثنتين.",
    "dispatchedAt": "وقت الشحن",
    "recordDispatch": "تسجيل الشحن",
    "dispatchRecorded": "تم تسجيل الشحن.",
    "document": "عرض مستند الأمر",
    "answerNotes": "رسالة مع ردك",
    "dispatchNotes": "ملاحظات عن هذه الشحنة",
    "portalNavigation": "بوابة المورد",
    "enquiries": "طلبات العروض",
    "answerEffect": {
      "acknowledged": "تقبل هذا الإصدار من الأمر. وأضف تاريخ التسليم المتوقع إن كان مختلفاً.",
      "partially_available": "حدّد لكل بند الكمية التي تستطيع توفيرها، ويقرّر المشتري الخطوة التالية.",
      "query": "يُرسل سؤالك إلى المشتري، ويبقى ردّك على الأمر معلّقاً.",
      "declined": "السبب مطلوب، ويُبلَّغ المشتري."
    },
    "dispatchSeparately": "للإبلاغ عن شحنة استخدم «تسجيل شحنة» أدناه، فهو إبلاغ وليس رداً.",
    "invoiceNotShown": "لا يظهر هنا",
    "noOrdersHint": "تظهر أوامر الشراء هنا عندما يرسلها المشتري.",
    "orderColumn": "الأمر",
    "datesColumn": "التواريخ",
    "nextColumn": "الإجراء التالي",
    "versionShort": "الإصدار {{version}}",
    "requestedBy": "مطلوب بحلول",
    "yourDate": "تاريخك",
    "notGivenYet": "لم يُحدَّد بعد",
    "afterRequested": "بعد التاريخ المطلوب",
    "nothingNeeded": "لا شيء مطلوب",
    "acknowledgeOrder": "تأكيد الأمر",
    "acknowledgeNewVersion": "تأكيد الإصدار الجديد",
    "respondToOrder": "الرد"
  },
  "secureAction": {
    "viewDocument": "عرض مستند الأمر",
    "rfqTitle": "طلب عرض سعر",
    "rfqIntro": "تمت دعوتك لتقديم عرض سعر. سجّل الدخول إلى بوابة المورد لإرسال أسعارك.",
    "linkVersionNote": "أُرسل هذا الرابط مع الإصدار {{link}}، ويُسجَّل ردك عليه. وقد حُدِّث الأمر بعد ذلك إلى الإصدار {{current}}.",
    "shellLabel": "رابط مورد آمن",
    "scopeGeneric": "يخص هذا الرابط أمراً واحداً لمورد واحد، ولا يتيح الوصول إلى أي شيء آخر.",
    "scopeOrder": "هذا الرابط خاص بأمر الشراء {{number}} وبـ{{supplier}}، ولا يتيح الوصول إلى أوامر أو موردين آخرين أو إلى نظام المشتري.",
    "noPayment": "لا تعالج فيدلِن المدفوعات بين المشتري والمورد.",
    "unavailableTitle": "لم يعد هذا الرابط متاحاً",
    "unavailableBody": "اطلب من المشتري الذي أرسله إصدار رابط جديد.",
    "reference": "المرجع",
    "poTitle": "أمر الشراء",
    "versionOf": "الإصدار {{version}}",
    "issuedBy": "جهة الإصدار",
    "to": "إلى",
    "issued": "تاريخ الإصدار",
    "requiredBy": "التسليم المطلوب بحلول",
    "validUntil": "يعمل هذا الرابط حتى",
    "amendedTitle": "جرى تعديل هذا الأمر — الإصدار {{version}}",
    "amendedBody": "الإصدار {{version}} يحل محل الإصدار {{previous}}، ولم يعد إقرارك بالإصدار {{previous}} سارياً — يرجى الرد على هذا الإصدار.",
    "statusTitle": "حالة هذا الأمر",
    "yourResponse": "ردك",
    "invoiceNotShown": "لا يظهر في هذا الرابط",
    "linesTitle": "البنود — الإصدار {{version}}",
    "linesSubtitle": "عدد البنود: {{count}} · {{total}}",
    "respond": "الرد",
    "respondTitle": "ردك",
    "respondHint": "اختر رداً واحداً. طرح سؤال لا يُلزمك بالأمر.",
    "answers": {
      "confirm": "الإقرار وتأكيد التاريخ المطلوب",
      "confirmEffect": "تقبل كل بنود الأمر للتسليم بحلول {{date}}.",
      "confirmEffectNoDate": "تقبل كل بنود الأمر كما أُرسلت.",
      "propose": "الإقرار مع اقتراح تاريخ تسليم",
      "proposeEffect": "تقبل الأمر وتحدد التاريخ الذي يمكنك التسليم فيه، ويراه المشتري بجانب التاريخ الذي طلبه.",
      "query": "إرسال استفسار",
      "queryEffect": "يُرسل سؤالك إلى المشتري، ويبقى ردك على الأمر معلّقاً.",
      "decline": "الاعتذار عن الأمر",
      "declineEffect": "السبب مطلوب، ويُبلَّغ المشتري."
    },
    "portalOnly": "يُبلَّغ عن التوافر الجزئي والشحنات من خلال بوابة المورد.",
    "chooseFirst": "اختر رداً أولاً.",
    "proposedDate": "التاريخ الذي يمكنك التسليم فيه",
    "proposedDateHint": "المطلوب: {{date}}.",
    "dateRequired": "أدخل التاريخ الذي يمكنك التسليم فيه.",
    "question": "سؤالك",
    "declineReasonLabel": "سبب الاعتذار",
    "noteToBuyer": "ملاحظة للمشتري",
    "noteOptional": "اختياري.",
    "questionRequired": "اكتب سؤالك للمشتري.",
    "reasonRequired": "السبب مطلوب للاعتذار.",
    "send": "إرسال الرد",
    "sentTitle": "تم إرسال الرد",
    "sentBody": "{{answer}} — {{when}}. وقد أُبلغ المشتري.",
    "sentDate": "تاريخ التسليم الذي حددته: {{date}}",
    "sentUsed": "استُخدم هذا الرابط الآن. لأي شيء آخر يخص هذا الأمر، تواصل مع المشتري.",
    "failedTitle": "لم يُرسل ردك",
    "failedBody": "انقطع الاتصال قبل أن يصل ردك إلى المشتري. ما أدخلته ما زال في هذه الصفحة. أعد الإرسال، وإذا تعذّر مرة ثانية فتواصل مع المشتري مباشرة.",
    "buyerContact": "للتواصل مع المشتري:",
    "copy": "نسخ ردي",
    "copied": "تم النسخ",
    "sendAgain": "إعادة الإرسال",
    "alreadyAcknowledged": "تم الإقرار بالإصدار {{version}} في {{date}}. لا حاجة إلى رد آخر عبر هذا الرابط.",
    "completedReadOnly": "اكتمل هذا الأمر، ويبقى هنا لسجلاتك."
  },
  "purchasingUnit": {
    "title": "وحدات الشراء",
    "subtitle": "الأماكن التي تشتري منشأتك لها وتستلم فيها — تُضبط هنا منطقة كل وحدة ومركز تكلفتها وموقع استلامها",
    "empty": "لا توجد وحدات شراء",
    "create": "إضافة وحدة شراء",
    "kind": "تمثّل",
    "kindHint": "ما تمثّله وحدة الشراء هذه. نوعا «فرع» و«مستودع» فقط يرتبطان بتفاصيل تشغيلية في فِدلن.",
    "kindLocked": "لا يمكن تغيير ما تمثّله الوحدة. أنشئ وحدة جديدة بدلاً من ذلك.",
    "noLink": "غير مرتبطة",
    "unlinkedKindNotice": "لا توجد تفاصيل تشغيلية في فِدلن لربط هذا النوع بها، وهذا متوقع.",
    "activate": "تفعيل",
    "deactivate": "إيقاف",
    "deactivateNotice": "يحرّر هذا المقعد ويحتفظ بكل السجلات. اذكر السبب ليمكن تفسير التغيير لاحقاً.",
    "resolveLink": "معالجة الارتباط",
    "resolveLinkNotice": "يسجّل هذا أن التعارض معروف ومقبول. لا يغيّر الحالة ولا يحرّر أي سعة.",
    "staleLink": "تفاصيلها التشغيلية («{{name}}») لم تعد نشطة",
    "capacityUsed": "{{used}} من {{limit}} نشطة",
    "capacityUnlimited": "{{used}} نشطة — بلا حد",
    "capacityFull": "لا توجد سعة متبقية. أوقف وحدة أو تواصل معنا لزيادة السعة.",
    "archive": "أرشفة",
    "archiveNotice": "تحتفظ الأرشفة بتاريخ هذه الوحدة ومراجعها وصلاحياتها، وتحرّر مقعدها. لا يمكن التراجع عنها: لا تُفعَّل الوحدة المؤرشفة مرة أخرى. اذكر السبب ليمكن تفسير التغيير لاحقاً.",
    "archived": "مؤرشفة",
    "operational": {
      "title": "التفاصيل التشغيلية",
      "hint": "أين تشتري هذه الوحدة وتستلم: منطقتها ومركز تكلفتها وهل تستلم التوريدات.",
      "record": "التفاصيل المرتبطة",
      "recordNew": "إعداد تفاصيل جديدة مع هذه الوحدة",
      "code": "الرمز التشغيلي",
      "codeHint": "الرمز الذي تعرف به الاستيرادات والتقارير هذه التفاصيل. اتركه فارغاً لاستخدام رمز الوحدة نفسه.",
      "nameSync": "إعادة تسمية الوحدة تعيد تسمية تفاصيلها أيضاً، فتظهر الطلبات والميزانيات والتقارير بالاسم نفسه.",
      "readOnly": "يمكنك قراءة هذه التفاصيل هنا دون تغييرها.",
      "archived": "وحدة الشراء هذه مؤرشفة، فتبقى تفاصيلها كما هي ولا يمكن تغييرها.",
      "relinkHint": "احفظ لربط هذه التفاصيل بالوحدة."
    }
  },
  "receiving": {
    "title": "الاستلام",
    "subtitle": "عمليات تسليم بانتظار التسجيل",
    "empty": "لا يوجد ما ينتظر الاستلام",
    "alreadyAccepted": "المقبول سابقاً",
    "remaining": "المتبقي",
    "deliveredQuantity": "الكمية التي وصلت",
    "acceptedQuantity": "الكمية المقبولة",
    "acceptedHint": "يمكنك قبول ما لا يتجاوز المتبقي. وأي زيادة تُسجَّل كتسليم زائد.",
    "exceptionType": "إن كان هناك خلل",
    "exceptionReason": "ما هو الخلل",
    "deliveryNoteRef": "إشعار تسليم المورد",
    "receiptNotes": "ملاحظات على هذا التسليم",
    "receiveEverything": "وصل كل شيء بشكل صحيح",
    "receiveEntered": "تسجيل ما أدخلته",
    "recorded": "تم تسجيل الاستلام.",
    "history": "سجل الاستلام",
    "noReceipts": "لم يُستلم شيء بعد",
    "closeShortHint": "استخدم هذا حين لا يُتوقع وصول الكمية المتبقية ضمن هذا الأمر. يُحرِّر الميزانية المحجوزة لها ولا يمكن التراجع عنه.",
    "closeShortReason": "ما سبب إقفال المتبقي؟",
    "closeShortAction": "الإقفال بنقص",
    "exceptionQuantity": "الكمية المتأثرة",
    "exceptionQuantityRequired": "أدخل عدد الوحدات التي ينطبق عليها هذا.",
    "orderColumn": "الأمر",
    "datesColumn": "التواريخ",
    "supplierAnswer": "رد المورد",
    "receive": "استلام",
    "emptyHint": "تظهر الأوامر هنا بعد إصدارها وحين يُتوقَّع وصولها إلى وحدات الشراء التابعة لك.",
    "receiveOrder": "استلام الأمر",
    "acceptAllRemaining": "قبول كل المتبقي",
    "lineMeta": "البند {{number}} · {{unit}}",
    "lineReceived": "استُلم بالكامل",
    "lineClosedShort": "أُقفل بنقص",
    "addException": "الإبلاغ عن خلل",
    "deliveryDetails": "تفاصيل التسليم",
    "wholeDelivery": "التسليم كاملاً",
    "overdueExplain": "استخدم هذا حين لا يصل تسليم كان متوقعاً.",
    "reportOverdue": "الإبلاغ عن تأخر التسليم",
    "overdueEntered": "أُبلغ عن تأخر التسليم",
    "closeOrderShort": "إقفال الأمر بنقص",
    "closeShortTitle": "إقفال هذا الأمر بنقص؟",
    "notRecorded": "لم يُسجَّل الاستلام",
    "onLine": "البند {{number}}: {{name}}.",
    "commitHint": "يُسجَّل ما وصل اليوم فقط. لا يمكن تعديل الاستلام بعد تسجيله — التصحيح يكون باستلام إضافي.",
    "enteredLines": "البنود المُدخلة: {{count}}",
    "acceptedNow": "المقبول الآن: {{quantity}} {{unit}}",
    "receiptSummary": "البنود: {{lines}} · على الإصدار {{version}}",
    "receiptLine": "{{name}} — وصل {{delivered}}، قُبل {{accepted}}",
    "unknownLine": "بند لم يعد في الأمر",
    "problem": {
      "notANumber": "أدخل رقماً، مثل 12 أو 2.5.",
      "acceptedOverDelivered": "لا يمكن أن تتجاوز الكمية المقبولة ما وصل.",
      "acceptedOverRemaining": "يمكنك قبول {{remaining}} كحد أقصى. أبلغ عن الباقي كتسليم زائد.",
      "unexplainedShortfall": "لم يُقبل جزء مما وصل. أبلغ عن الخلل ليُسجَّل السبب.",
      "reasonMissing": "اذكر ما هو الخلل."
    }
  },
  "invoice": {
    "title": "فواتير الموردين",
    "captureHint": "سجِّل الفاتورة التي أرسلها المورد. يحفظها فيدلِن كدليل — ولا يصدرها ولا يعتمدها ولا يدفعها.",
    "record": "تسجيل فاتورة",
    "missing": "لم تُسجَّل أي فاتورة مورد بعد",
    "number": "رقم فاتورة المورد",
    "date": "تاريخ الفاتورة",
    "subtotal": "المجموع الفرعي",
    "tax": "الضريبة",
    "total": "الإجمالي",
    "file": "ملف فاتورة المورد (PDF)",
    "fileHint": "ملفات PDF فقط، حتى 10 ميجابايت. تُحفظ بشكل خاص ولا يراها إلا المخوَّلون.",
    "save": "حفظ الفاتورة",
    "download": "تنزيل ملف الفاتورة",
    "exceedsOrder": "قيمة هذه الفاتورة أعلى من قيمة الأمر. سُجِّلت كما وردت، ولا يُعتمد شيء تلقائياً."
  },
  "sourcing": {
    "title": "التوريد",
    "subtitle": "طلبات عروض محكومة إلى مورديك المؤهلين",
    "deadline": "موعد استلام العروض",
    "closed": "مغلق",
    "responses": "العروض",
    "responseCount": "{{answered}} من {{invited}} ردّوا",
    "requirement": "المطلوب",
    "invited": "الموردون المدعوون",
    "comparison": "مقارنة العروض",
    "comparisonHint": "الحقائق نفسها لكل مورد. لا يقوم فيدلِن بتقييمها أو ترتيبها — القرار قرارك.",
    "noQuotes": "لم يرد أي مورد بعد",
    "supplier": "المورد",
    "total": "الإجمالي",
    "validUntil": "السعر ساري حتى",
    "moq": "أقل كمية للطلب",
    "leadTime": "مدة التوريد",
    "availability": "التوفر",
    "expired": "منتهي",
    "days_zero": "{{count}} يوم",
    "days_one": "يوم واحد",
    "days_two": "يومان",
    "days_few": "{{count}} أيام",
    "days_many": "{{count}} يوماً",
    "days_other": "{{count}} يوم",
    "choose": "اختيار",
    "chooseSupplier": "اختيار {{supplier}}",
    "decision": "تسجيل قرارك",
    "awardHint": "الترسية تحوّل العرض الفائز إلى اتفاقية إطارية مسودة لوحدة الشراء التي جاء منها الاحتياج. ولا تُنشئ أمر شراء ولا تلتزم بأي ميزانية، ولا يُشترى منها شيء حتى يفعّلها من يملك صلاحية الاتفاقيات.",
    "awardReason": "لماذا هذا المورد؟",
    "award": "الترسية على المورد المختار",
    "noAwardReason": "لماذا لا تتم الترسية على أحد؟",
    "noAward": "الإغلاق دون ترسية",
    "awarded": "تمت الترسية",
    "agreementCreated": "تم إنشاء الاتفاقية الإطارية {{reference}}. ويتم الشراء الآن وفق قواعد الطلب والاعتماد المعتادة.",
    "awardCatalogueItems": "اشترِه من الكتالوج باسم:",
    "awardNotInCatalogue": "لا يوجد في الكتالوج بعدُ صنف مسعَّر بهذه الترسية، لذا لا يمكن طلبه حتى تضيف إدارة الكتالوج صنفاً له.",
    "awardDraftAgreement": "الاتفاقية الإطارية (مسودة):",
    "awardAgreement": "الاتفاقية الإطارية:",
    "awardDraftCoverage": "تنطبق على: {{units}}",
    "awardDraftCoverageAll": "تنطبق على: كل وحدات الشراء",
    "awardDraftCoverageNone": "تنطبق على: لا توجد وحدة شراء بعد — مطلوبة قبل التفعيل",
    "awardDraftValidTo": "سارية حتى {{date}}",
    "awardDraftValidityNeeded": "سارية حتى: مطلوب قبل التفعيل",
    "awardDraftNotBuyable": "لا يمكن الشراء منها قبل تفعيل الاتفاقية.",
    "awardWithdrawn": "سُحبت الترسية في {{date}}: أُعيد الاحتياج إلى التوريد.",
    "awardDraftCatalogueItems": "بعد تفعيل الاتفاقية، يُشترى من الكتالوج باسم:",
    "agreementActive": "الاتفاقية الإطارية {{reference}} نشطة. ويتم الشراء الآن وفق قواعد الطلب والاعتماد المعتادة.",
    "documents": "المستندات",
    "fromRevision": "المراجعة {{revision}}",
    "sendToSourcing": "إرسال إلى التوريد",
    "sendToSourcingHint": "سيتولى قسم المشتريات طلب عروض من موردين معتمدين. يُحدَّد المورد والسعر هنا، لا من قِبل من رفع الاحتياج.",
    "startRfq": "بدء طلب عروض",
    "rfqTitle": "ما الذي يجري توريده",
    "currencyHint": "يقدّم الموردون عروضهم بهذه العملة. عملة واحدة لكل طلب عروض.",
    "terms": "الشروط",
    "linesHeading": "ما سيقدّم الموردون عروضاً عليه",
    "linesHint": "منقول من الاحتياج. يحدد الموردون أسعارهم، ولا يُحدَّد أي سعر هنا.",
    "linesEmpty": "لا توجد بنود منقولة من الاحتياج.",
    "createRfq": "إنشاء طلب العروض",
    "cancelRfq": "إلغاء طلب العروض",
    "closeOutcomeHint": "«بلا ترسية» تُغلق طلب عروض جرى تنفيذه دون نتيجة تستحق الترسية. أما «الإلغاء» فيغلق طلباً ما كان ينبغي تنفيذه. ويُسجَّل كلاهما مع السبب الذي تذكره.",
    "inviteHeading": "دعوة الموردين المؤهلين",
    "inviteHint": "يُعرض فقط الموردون الذين أهّلتموهم ويمكن الشراء منهم. اختيار أكثر من مورد أمر معتاد — فهذا طلب عروض وليس تفضيلاً.",
    "openRfq": "فتح الطلب للموردين",
    "noEligibleSuppliers": "لا يوجد موردون معتمدون متاحون للدعوة.",
    "workColumn": "بند العمل",
    "originColumn": "المصدر",
    "keyDateColumn": "التاريخ المهم",
    "notYetOpen": "لم يُفتح للموردين بعد",
    "itemCount": "العناصر: {{count}}",
    "needsFailed": "تعذّر تحميل الاحتياجات التي تنتظر طلب عروض",
    "queueEmpty": "لا يوجد ما ينتظر في التوريد",
    "queueEmptyHint": "تظهر هنا الاحتياجات المُحالة إلى التوريد وطلبات العروض المنشأة لها.",
    "queueFootnote": "تظهر الاحتياجات هنا قبل إنشاء طلب عروض لها. يفتح «بدء طلب عروض» نموذج الطلب — ولا يُنشأ شيء حتى تؤكد هناك.",
    "kindNeed": "احتياج",
    "kindRfq": "طلب عروض",
    "noNumberYet": "بلا رقم حتى الفتح",
    "startSubtitle": "أنشئ مسودة طلب عروض من هذا الاحتياج. لا يُرسل شيء إلى الموردين حتى تفتحه.",
    "startNotAllowed": "لا يتيح دورك إنشاء طلبات العروض. يُنشئها قسم المشتريات من الاحتياجات في قائمة التوريد.",
    "notCreated": "لم يُنشأ طلب العروض",
    "detailsHeading": "تفاصيل طلب العروض",
    "rfqTitleHint": "الاسم الذي سيراه الموردون لطلب العروض.",
    "deadlineHint": "يسري بعد فتح الطلب للموردين. بتوقيتك المحلي.",
    "currencyFromRequest": "من الطلب. عملة واحدة لكل طلب عروض.",
    "addLine": "إضافة بند",
    "lineNumber": "البند {{number}}",
    "lineItem": "الصنف",
    "termsHeading": "الشروط والملاحظات",
    "termsHint": "تظهر للموردين عند فتح الطلب. اقتصر على شروط تقديم العروض — لا التزامات ترسية أو شراء.",
    "internalNotes": "ملاحظات داخلية",
    "internalNotesHint": "لا يراها الموردون.",
    "draftSummary": "ملخص المسودة",
    "fromRequest": "من الطلب",
    "linesCount": "البنود",
    "noneYet": "لا أحد بعد",
    "enquiryNumber": "رقم طلب العروض",
    "numberWhenOpened": "يُعيَّن عند الفتح",
    "notContactedTitle": "لم يُتواصل مع الموردين بعد",
    "notContactedBody": "إنشاء المسودة يسجّل طلب العروض فقط. تدعو الموردين المؤهلين وتفتحه في الخطوة التالية.",
    "next1": "تُنشأ مسودة طلب العروض.",
    "next2": "تراجع المسودة.",
    "next3": "تدعو الموردين المؤهلين.",
    "next4": "تفتحه لاستقبال العروض.",
    "createNote": "يُنشئ مسودة مرتبطة بـ {{request}}. لا يُرسل شيء إلى الموردين.",
    "createNoteNoRequest": "يُنشئ مسودة طلب عروض. لا يُرسل شيء إلى الموردين.",
    "sourceRequest": "الطلب المصدر",
    "request": "الطلب",
    "needNotInSourcing": "هذا الاحتياج لا ينتظر التوريد (حالته: {{status}}). راجعه قبل إنشاء طلب عروض.",
    "eyebrowDraft": "مسودة طلب عروض",
    "numberAssignedWhenOpened": "يُعيَّن الرقم عند الفتح",
    "draftDescription": "راجع طلب العروض، واختر الموردين المؤهلين، ثم افتحه لاستقبال العروض.",
    "stepsLabel": "مرحلة طلب العروض",
    "stepSuppliers": "الموردون",
    "stepOpen": "الفتح",
    "definitionHeading": "تعريف طلب العروض",
    "definitionSubtitle": "حُدِّد عند إنشاء المسودة.",
    "currencyLabel": "العملة",
    "plannedDeadline": "موعد العروض المخطط",
    "category": "الفئة",
    "created": "تاريخ الإنشاء",
    "termsShown": "الشروط · تظهر للموردين عند الفتح",
    "notesInternal": "ملاحظات داخلية · للمشتريات فقط",
    "none": "لا يوجد",
    "searchSuppliers": "بحث في الموردين",
    "inviteColumn": "دعوة",
    "inviteSupplier": "دعوة {{supplier}}",
    "eligibility": "الأهلية",
    "qualification": "التأهيل",
    "qualifiedBadge": "مؤهل",
    "qualifiedUntil": "مؤهل حتى {{date}}",
    "noEndDate": "بلا تاريخ انتهاء",
    "readyToOpen": "جاهز للفتح؟",
    "selectedSuppliers": "الموردون المختارون",
    "invitedSoFar": "المدعوون حتى الآن",
    "nothingSentYet": "لا أحد — لم يُرسل شيء بعد",
    "willBeInvited": "ستتم دعوتهم",
    "noneSelected": "لم يُختر أحد بعد",
    "whatOpeningDoes": "ماذا يفعل الفتح",
    "opening1": "يدعو الموردين المختارين.",
    "opening2": "يطلب منهم تقديم عروضهم بحلول {{deadline}}.",
    "opening3": "لا يرى كل مورد إلا دعوته.",
    "opening4": "لا تتم ترسية ولا اتفاق ولا طلب شراء.",
    "openNote": "يدعو الفتح الموردين المختارين ويتيح لهم تقديم عروضهم حتى الموعد. يلزم مورد واحد على الأقل.",
    "deadlinePassed": "انتهى موعد العروض",
    "invitedNote": "يظهر كل مورد مدعو، بمن فيهم من لم يردّ.",
    "invitedNoteClosed": "انتهت مهلة العروض، وعدم الرد ليس عرضاً.",
    "revisionSent": "المراجعة {{revision}} · أُرسلت {{date}}",
    "inclTax": "شاملة الضريبة {{amount}}",
    "expiredNotChoosable": "انتهت صلاحيته — لا تمكن الترسية عليه",
    "chosenOffer": "العرض المختار",
    "chooseFirst": "اختر عرضاً من المقارنة أولاً.",
    "awardReasonHint": "مطلوب. يُسجَّل مع الترسية دليلاً على قرار التوريد.",
    "awardConsequence": "يصبح سعر العرض الفائز وضريبته ومدة توريده وصلاحيته اتفاقيةً مسودة، تُفعَّل بإجراء منفصل قبل أن يُطلب أي شيء عبر مسار الطلبات المعتاد.",
    "orCloseNoAward": "أو الإغلاق دون ترسية",
    "noAwardExplain": "لا يُختار أي مورد من طلب العروض هذا، ويبقى الطلب الأصلي كما هو.",
    "closeReasonHint": "مطلوب للإغلاق.",
    "usualLeadTime_zero": "مدة التوريد المعتادة (أيام): {{count}}",
    "usualLeadTime_one": "مدة التوريد المعتادة (أيام): {{count}}",
    "usualLeadTime_two": "مدة التوريد المعتادة (أيام): {{count}}",
    "usualLeadTime_few": "مدة التوريد المعتادة (أيام): {{count}}",
    "usualLeadTime_many": "مدة التوريد المعتادة (أيام): {{count}}",
    "usualLeadTime_other": "مدة التوريد المعتادة (أيام): {{count}}",
    "requestedBy": "مقدّم الطلب",
    "purchasingNode": "وحدة الشراء",
    "requiredBy": "التسليم المطلوب بحلول",
    "startedWithoutRequest": "لا يوجد — بدأ دون طلب",
    "notAvailableToYou": "غير متاح بصلاحياتك",
    "notStatedOnRequest": "لم يُحدَّد في الطلب"
  },
  "vendorRfq": {
    "listTitle": "طلبات العروض",
    "listSubtitle": "طلبات تسعير مرسلة إليك",
    "none": "لا توجد طلبات بعد",
    "title": "طلب عرض",
    "deadline": "الرد بحلول",
    "closed": "لم يعد هذا الطلب يقبل العروض.",
    "requirement": "المطلوب",
    "unitPrice": "سعرك لكل {{unit}}",
    "yourOffer": "عرضك",
    "taxRate": "نسبة الضريبة (٪)",
    "validUntil": "السعر ساري حتى",
    "validUntilHint": "المدة التي ستثبّت فيها هذا السعر. وهي غير موعد الرد أعلاه.",
    "moq": "أقل كمية للطلب",
    "leadTime": "مدة التوريد (أيام)",
    "availability": "التوفر",
    "notes": "ملاحظات للمشتري",
    "submit": "إرسال عرضي",
    "revise": "إرسال عرض معدّل",
    "reviseUnchanged": "لم يتغير شيء منذ العرض الذي أرسلته للتو. غيّر سعرًا أو شرطًا لإرسال عرض معدّل.",
    "submitted": "تم إرسال عرضك.",
    "lastOffer": "عرضك الحالي",
    "revision": "المراجعة {{revision}}",
    "attachments": "المستندات",
    "noAttachments": "لا توجد مستندات مرفقة بعد.",
    "attachFile": "إضافة مستند",
    "attach": "إرفاق",
    "attachHint": "ملفات PDF فقط، بحد أقصى 10 ميجابايت. تُرفق بالعرض الذي قدمته.",
    "currency": "العملة",
    "fromBuyer": "من {{buyer}}",
    "unitPriceHint": "بعملة {{currency}}، دون الضريبة. تُدخل نسبة الضريبة مرة واحدة أدناه وتنطبق على كل البنود.",
    "buyerTerms": "شروط المشتري",
    "taxRateHint": "اختياري. تنطبق على كل البنود.",
    "moqHint": "اختياري. بالوحدة المطلوبة.",
    "leadTimeHint": "اختياري. عدد الأيام من الطلب حتى التسليم.",
    "availabilityHint": "اختياري. بكلماتك — مثل: متوفر، أو جزء الآن والباقي خلال أسبوعين.",
    "notesHint": "اختياري — سؤال أو شرط أو أي شيء ينبغي أن يعرفه المشتري.",
    "documentsAfterSending": "يمكنك إرفاق مستندات PDF (حتى 10 ميجابايت لكل منها) بعد إرسال عرضك، وتُرفق بالعرض الذي أرسلته.",
    "readyTitle": "جاهز للإرسال؟",
    "readyBody": "يشارك الإرسال هذا العرض مع {{buyer}} لتقييمه. إنه عرض وليس طلب شراء — ويمكنك إرسال عرض معدّل حتى موعد الرد.",
    "readyBodyNoBuyer": "يشارك الإرسال هذا العرض مع المشتري لتقييمه. إنه عرض وليس طلب شراء — ويمكنك إرسال عرض معدّل حتى موعد الرد.",
    "phaseOpen": "مفتوح لاستقبال العروض",
    "phaseClosed": "مغلق أمام العروض"
  },
  "onboarding": {
    "title": "التهيئة والاستيراد",
    "subtitle": "ما تم إعداده، وما هو متبقٍ، وكيفية تحميل البيانات الرئيسية.",
    "readiness": "الجاهزية للتشغيل",
    "ready": "جاهز",
    "outstanding_zero": "لا خطوات متبقية",
    "outstanding_one": "خطوة واحدة متبقية",
    "outstanding_two": "خطوتان متبقيتان",
    "outstanding_few": "{{count}} خطوات متبقية",
    "outstanding_many": "{{count}} خطوة متبقية",
    "outstanding_other": "{{count}} خطوة متبقية",
    "derivedHint": "تُقرأ كل خطوة أدناه من إعداداتك الفعلية. لا يوجد ما يُؤشَّر عليه — تكتمل الخطوة عند وجود السجلات التي تحتاجها وهي قيد الاستخدام، كأن تكون نشطة أو سارية. تُحتسب السجلات غير النشطة والمؤرشفة في العدد، لكنها لا تُكمل أي خطوة.",
    "optional": "اختياري",
    "configured": "{{count}} مُعدّ",
    "notConfigured": "لم يُعدّ بعد",
    "owner": "المسؤول",
    "ownerYou": "أنت",
    "ownerNoRole": "لا يوجد دور بعد",
    "ownerNobody": "لا أحد يملكها بعد",
    "ownerDetails": "تفاصيل المسؤول",
    "ownerRolesTitle": "الأدوار التي يمكنها إتمام هذه الخطوة",
    "ownerPeopleCount": "الأشخاص النشطون: {{count}}",
    "ownerPeopleHidden": "تظهر الأسماء لمن يدير المستخدمين.",
    "ownerNoRoleHint": "لا يوجد دور يملك صلاحية هذه الخطوة، لذا لا يستطيع أحد إتمامها. أضف الصلاحية إلى دور من صفحة الأدوار.",
    "ownerNobodyHint": "الدور موجود لكن لا يشغله أي شخص نشط. أسنِده إلى مستخدم من صفحة المستخدمين.",
    "ownerHint": "المسؤول هو من يملك صلاحية تنفيذ الخطوة. يتبع أدوارك، فلا يتقادم أبداً.",
    "steps": {
      "regions": "المناطق",
      "branches": "وحدات الشراء",
      "categories": "شجرة التصنيفات",
      "users": "المستخدمون والأدوار",
      "defaults": "اللغة والمنطقة الزمنية والعملة الافتراضية",
      "approval_rules": "قواعد الاعتماد",
      "budgets": "الميزانيات",
      "suppliers": "الموردون",
      "agreements": "الاتفاقيات الإطارية",
      "catalogue": "كتالوج بأسعار قابلة للاستخدام",
      "purchasing_path": "إمكانية إتمام الشراء في كل وحدة شراء"
    },
    "staffingTitle": "هل يمكن إتمام الشراء في كل وحدة شراء؟",
    "staffingHint": "يجب أن يوجد من يرفع الطلب، ومن يقرّر في كل مستوى اعتماد، ومن يستلم التوريد دون أن يستلم طلبه أو ما اعتمده.",
    "staffingAllClear": "كل وحدة شراء يمكن رفع طلب فيها يمكن إتمام الشراء فيها أيضاً.",
    "nodeBlocked": "متوقفة",
    "nodeAtRisk": "معرّضة للتعطّل",
    "nodeIdle": "لا يوجد بعد من يرفع طلب شراء هنا",
    "approvalUnstaffed": "يوجد مستوى اعتماد لا يوجد من يقرّر فيه.",
    "approvalNotDistinct": "مستويان من الاعتماد سيحتاجان الشخص نفسه.",
    "receivingUnstaffed": "لا يوجد من يحق له استلام التوريدات هنا.",
    "receivingAtRisk": "كل من يحق له الاستلام هنا يرفع طلبات أو يعتمدها هنا أيضاً، لذا تحتاج طلباتهم إلى من يستلمها غيرهم.",
    "import": "استيراد البيانات الرئيسية",
    "importHint": "ارفع ملف CSV أو Excel. يُفحص أولًا ولا يُنشأ شيء حتى تعتمده.",
    "entity": "ما المطلوب استيراده",
    "branchesHint": "يُعدّ كل صف التفاصيل التشغيلية لوحدة شراء: الرمز والاسم بالعربية والإنجليزية والمنطقة ومركز التكلفة والهاتف والبريد الإلكتروني والمدينة. لا يُنشئ الاستيراد وحدات شراء. أضف وحدة لهذه التفاصيل، أو اربطها بوحدة موجودة، من صفحة وحدات الشراء.",
    "openPurchasingUnits": "فتح وحدات الشراء",
    "file": "الملف",
    "columns": "الأعمدة",
    "requiredColumns": "المطلوبة",
    "check": "فحص الملف",
    "history": "عمليات الاستيراد الأخيرة",
    "noImports": "لا توجد عمليات استيراد بعد.",
    "nothingWrittenYet": "لم يُنشأ أي شيء بعد. سيؤدي الاعتماد إلى إنشاء الصفوف الجاهزة فقط.",
    "apply_zero": "لا صفوف للاعتماد",
    "apply_one": "اعتماد صف واحد",
    "apply_two": "اعتماد صفين",
    "apply_few": "اعتماد {{count}} صفوف",
    "apply_many": "اعتماد {{count}} صفاً",
    "apply_other": "اعتماد {{count}} صف",
    "applied_zero": "لم يُنشأ أي صف.",
    "applied_one": "تم إنشاء صف واحد.",
    "applied_two": "تم إنشاء صفين.",
    "applied_few": "تم إنشاء {{count}} صفوف.",
    "applied_many": "تم إنشاء {{count}} صفاً.",
    "applied_other": "تم إنشاء {{count}} صف.",
    "problems": "صفوف تحتاج إلى مراجعة",
    "allRows": "كل الصفوف",
    "line": "السطر",
    "field": "الحقل",
    "reason": "السبب",
    "outcome": "النتيجة",
    "stepNeeded": "لازمة للتشغيل",
    "done": "جاهزة",
    "open": "فتح",
    "fileHint": "المقبول: {{formats}} · حتى {{rows}} صف في الملف.",
    "cannotRun": "يتيح لك دورك الاطلاع على عمليات الاستيراد دون تنفيذها.",
    "rows": "الصفوف",
    "rowsApplied": "أُنشئ {{applied}} من {{total}}",
    "rowsValid": "{{valid}} من {{total}} جاهز",
    "rejectedTitle": "رُفض الملف",
    "rejectedNoReason": "تعذّرت قراءة الملف.",
    "applyFinal": "لا يمكن التراجع عن الاعتماد.",
    "nothingToApply": "لا يوجد صف جاهز للاعتماد — صحّح الملف وافحصه مجدداً.",
    "checksum": "بصمة الملف",
    "noRows": "لم تُقرأ أي صفوف.",
    "countTotal": "الصفوف",
    "countValid": "جاهز",
    "countInvalid": "بها مشكلات",
    "countApplied": "أُنشئ",
    "countSkipped": "موجود مسبقاً"
  },
  "supplierFacts": {
    "title": "حقائق الموثوقية",
    "hint": "محسوبة من تعاملاتك أنت مع هذا المورد خلال آخر اثني عشر شهرًا. هذه حقائق وليست تقييمًا.",
    "ordersIssued": "أوامر الشراء الصادرة",
    "ordersAcknowledged": "أوامر تم إقرارها",
    "responseTime": "متوسط زمن الاستجابة",
    "deliveriesReceived": "التسليمات المستلمة",
    "deliveriesOnTime": "سُلّمت في الموعد",
    "shortDeliveries": "تسليمات ناقصة",
    "invoicesCaptured": "الفواتير المسجلة",
    "hours": "{{hours}} ساعة",
    "noData": "لا توجد استجابات بعد"
  },
  "reports": {
    "hubSubtitle": "تقارير تشغيلية مباشرة، مستخرجة من السجلات نفسها.",
    "dashboards": "اللوحات والتقارير",
    "records": "السجلات",
    "recordsHint": "الصفوف التي بُنيت عليها الأرقام — تُصفّى وتُصدَّر بالنطاق نفسه.",
    "recordsSubtitle": "الاستعلام نفسه الذي احتُسبت منه الأرقام.",
    "noExportRight": "يمكنك قراءة هذه التقارير دون تصديرها. اطلب صلاحية التصدير من مدير النظام.",
    "export": "تصدير",
    "from": "من",
    "to": "إلى",
    "groupBy": "التجميع حسب",
    "window": "الفترة",
    "scope": "المواقع",
    "allLocations": "كل المواقع",
    "locationCount_zero": "لا مواقع",
    "locationCount_one": "موقع واحد",
    "locationCount_two": "موقعان",
    "locationCount_few": "{{count}} مواقع",
    "locationCount_many": "{{count}} موقعاً",
    "locationCount_other": "{{count}} موقع",
    "generatedAt": "تاريخ الإصدار",
    "howToRead": "كيف تُقرأ هذه الأرقام",
    "viewRecords": "عرض السجلات",
    "noRows": "لا توجد بيانات لهذه الفترة والنطاق.",
    "empty": "لا توجد أرقام لهذه الفترة.",
    "available": "التقارير المتاحة",
    "report": "التقرير",
    "computing": "يُحسب هذا التقرير من سجلاتك — لا شيء مخزّن مسبقاً.",
    "choose": "اختر تقريراً أو مجموعة سجلات من القائمة."
  },
  "dashboard": {
    "openReports": "فتح التقارير",
    "yourWork": "عملك",
    "myRequests": "طلباتي",
    "awaitingMyDecision": "بانتظار قرارك",
    "noFigures": "لا توجد بيانات لعرضها ضمن صلاحياتك.",
    "newRequest": "طلب شراء جديد",
    "moreFigures": "مؤشرات أخرى",
    "attention": "بحاجة إلى متابعة",
    "review": "مراجعة",
    "decisionsTitle": "قرارات بانتظارك",
    "decisionsCount": "بانتظارك: {{count}}",
    "openQueue": "فتح قائمة الاعتمادات",
    "noDecisions": "لا يوجد ما ينتظر قرارك.",
    "raisedBy": "مقدّم الطلب",
    "due": "موعد القرار",
    "overdue": "متأخر",
    "budgetTitle": "وضع الميزانية",
    "noBudgets": "لا توجد ميزانية مُعدّة للمواقع المتاحة لك.",
    "overAllocation": "تجاوز المبلغ المخصص",
    "availableOf": "المتاح {{available}} من {{allocated}}",
    "noExceptions": "لا توجد استثناءات استلام في هذه الفترة.",
    "spendTitle": "قيمة أوامر الشراء حسب الفئة",
    "spendBasis": "أوامر صادرة خلال الفترة وغير ملغاة",
    "noSpend": "لم تصدر أوامر شراء في هذه الفترة.",
    "otherCategories": "فئات أخرى",
    "latestRequests": "أحدث طلباتي",
    "viewAll": "عرض الكل"
  },
  "vendorInvoice": {
    "title": "فواتيرك لهذا الأمر",
    "hint": "أرسل الفاتورة التي أصدرتها لهذا الأمر. يسجّلها فيدلِن مقابل إصدار الأمر ويحفظها كدليل — وهي ليست طلب سداد ولا تحدد موعد استلامك للمبلغ.",
    "send": "إرسال الفاتورة",
    "none": "لم ترسل فاتورة لهذا الأمر بعد."
  },
  "vendorProfile": {
    "title": "شركتك",
    "subtitle": "ما هو مسجّل عن شركتك لدى هذه المنشأة. لتعديل أي بيان، تواصل معها.",
    "noContacts": "لا توجد جهات اتصال مسجّلة."
  },
  "vendorAgreements": {
    "title": "الاتفاقيات",
    "subtitle": "الاتفاقيات الإطارية التي أنت طرف فيها مع هذه المنشأة.",
    "empty": "لا توجد لديك اتفاقيات إطارية مع هذه المنشأة."
  },
  "catalogueAdmin": {
    "title": "إدارة الكتالوج",
    "subtitle": "ما هو موجود، ومن أين يأتي، ومن يمكنه رؤيته",
    "empty": "لا توجد أصناف في الكتالوج بعد.",
    "create": "إضافة صنف",
    "orderable": "قابل للطلب",
    "orderableYes": "قابل للطلب",
    "orderableNo": "غير قابل للطلب",
    "access": "وصول وحدات الشراء",
    "restricted": "مقصور على وحدات شراء محددة",
    "allNodes": "متاح لكل وحدات الشراء",
    "sources": "المصادر",
    "manageSources": "المصادر",
    "noSources": "لا يوجد مصدر لهذا الصنف، لذلك لا يمكن لأحد طلبه.",
    "addSource": "إضافة مصدر",
    "removeSource": "إزالة",
    "sourceType": "نوع المصدر",
    "agreementItem": "بند الاتفاقية",
    "agreementItemHint": "يأتي السعر من بند الاتفاقية، ولا يُكتب هنا إطلاقاً.",
    "warehouseNotice": "المصدر المستودعي يُلبّى داخلياً. لا يُنشئ أمر شراء ولا يصل إلى أي مورد.",
    "nameEn": "الاسم (إنجليزي)",
    "nameAr": "الاسم (عربي)",
    "descriptionEn": "الوصف (إنجليزي)",
    "descriptionAr": "الوصف (عربي)",
    "accessHint": "اختر وحدات الشراء التي يمكنها رؤية هذا الصنف. تركه بلا تقييد يجعله متاحاً لكل وحدات الشراء.",
    "restrictToggle": "التقييد على وحدات شراء محددة",
    "saveAccess": "حفظ الوصول",
    "restrictedToNone": "التقييد دون اختيار أي وحدة شراء يعني ألا يراه أحد."
  },
  "portalUser": {
    "invite": "دعوة حساب بوابة",
    "invited": "تم إنشاء حساب البوابة",
    "invitedNotice": "تم إنشاء حساب لـ {{email}}.",
    "password": "كلمة المرور",
    "passwordOnce": "تظهر كلمة المرور هذه مرة واحدة ولا يمكن قراءتها مرة أخرى. سلّمها الآن؛ وإذا فُقدت فادعُ الحساب من جديد.",
    "capabilities": "ما يمكن لهذا الحساب فعله",
    "acknowledgeOrders": "إقرار أوامر الشراء",
    "submitQuotes": "تقديم عروض الأسعار",
    "uploadInvoices": "تقديم الفواتير",
    "activate": "تفعيل",
    "deactivate": "إيقاف",
    "deactivateNotice": "لن يتمكن المورد بعد ذلك من تسجيل الدخول بهذا الحساب أو الرد على طلبات عروض الأسعار أو إقرار الأوامر.",
    "noneConsequence": "بدون حساب بوابة لا يستطيع هذا المورد الرد على طلب عرض سعر أو إقرار أمر شراء أو تقديم فاتورة."
  },
  "tenant": {
    "profile": "ملف المنشأة",
    "profileSubtitle": "هوية منشأتك كما تسجّلها مستنداتها",
    "identity": "الاسم",
    "registration": "السجل ووسائل التواصل",
    "registrationHint": "تظهر هذه البيانات في المستندات التي تصدرها منشأتك وتستلمها.",
    "legalNameEn": "الاسم النظامي (إنجليزي)",
    "legalNameAr": "الاسم النظامي (عربي)",
    "timezone": "المنطقة الزمنية",
    "fixed": "محدد عند إنشاء المنشأة",
    "readOnly": "يمكنك الاطلاع على هذا الملف دون تعديله."
  },
  "exceptions": {
    "none": "لا يوجد ما يخالف قواعد الشراء.",
    "rule": "القاعدة: {{rule}}",
    "tone": {
      "exception": "يتطلب تدخلاً",
      "warning": "تنبيه",
      "neutral": "للعلم"
    }
  },
  "partial": {
    "includeLine": "تضمين {{name}}",
    "requested": "المطلوب {{quantity}}",
    "earlierLimit": "سمح مستوى سابق بـ {{quantity}}",
    "unitPrice": "{{price}} للوحدة",
    "overCeiling": "الحد الأقصى {{quantity}}. يمكن للمعتمد تخفيض الكمية ولا يمكنه زيادتها.",
    "positive": "أدخل كمية أكبر من صفر، أو استبعد البند.",
    "summaryLines": "البنود المعتمدة",
    "summaryUnits": "الوحدات المعتمدة",
    "summaryApproved": "القيمة المعتمدة",
    "summaryNotApproved": "غير المعتمد",
    "previewNote": "معاينة: تُعاد الحسابات ويُتحقق منها عند التأكيد."
  },
  "decision": {
    "approveLast": "اعتماد الطلب كما هو. يكتمل الاعتماد.",
    "approveNext": "اعتماد الطلب كما هو. ينتقل إلى المستوى {{next}}.",
    "partialConsequence": "اعتماد بعض البنود أو كميات مخفّضة. السبب مطلوب.",
    "returnTitle": "إعادة للتعديل",
    "returnConsequence": "إرجاعه لإجراء تعديل. يبقى الطلب مفتوحاً.",
    "rejectTitle": "رفض",
    "rejectConsequence": "إنهاء الطلب. السبب مطلوب.",
    "currentLevel": "المستوى الحالي",
    "levelOf": "المستوى {{level}} من {{count}}",
    "dueOn": "مستحق في {{date}}",
    "actingFor": "تتولى هذه الخطوة بالتفويض من {{name}} حتى {{until}}. يُسجَّل قرارك قراراً بالتفويض، بالاسمين معاً.",
    "confirmActingFor": "تتخذ القرار نيابةً عن {{name}}. يُسجَّل الاسمان معاً.",
    "timelineActingFor": "تتولى هذه الخطوة بالتفويض من {{name}}.",
    "approveDialogTitle": "اعتماد هذا الطلب؟",
    "approveCommit": "تأكيد الاعتماد",
    "approveOutcomeLast": "يُسجَّل اعتمادك في المستوى {{level}}، وهو المستوى الأخير. يصبح الطلب معتمداً.",
    "approveOutcomeNext": "يُسجَّل اعتمادك في المستوى {{level}}. ينتقل الطلب إلى المستوى {{next}} — {{name}}.",
    "stillTrue": "ما زال قائماً على هذا الطلب",
    "noteOptional": "ملاحظة (اختيارية)",
    "noteHint": "تظهر لمقدّم الطلب وللمعتمدين اللاحقين.",
    "partialDialogTitle": "اعتماد جزء من هذا الطلب",
    "partialCommit": "اعتماد البنود: {{count}} · {{amount}}",
    "partialOutcomeLast": "هذا هو المستوى الأخير: يصبح الطلب معتمداً بالكميات التي تُبقيها.",
    "partialOutcomeNext": "تنتقل الكميات التي تُبقيها إلى المستوى {{next}}، الذي يمكنه تخفيضها ولا يمكنه زيادتها.",
    "reason": "سبب القرار",
    "reasonVisible": "مطلوب. يظهر لمقدّم الطلب وللمعتمدين اللاحقين.",
    "reasonRequired": "اذكر السبب.",
    "nothingReduced": "لم يُخفَّض شيء بعد. خفّض كمية أو استبعد بنداً — ولاعتماد الكل استخدم «اعتماد».",
    "nothingApproved": "استُبعدت جميع البنود. لإنهاء الطلب استخدم «رفض»، ولإرجاعه استخدم «إعادة للتعديل».",
    "returnDialogTitle": "إعادة هذا الطلب للتعديل",
    "returnCommit": "إعادة إلى مقدّم الطلب",
    "returnExplains": "يعود الطلب إلى مقدّمه لتعديله. يبقى مفتوحاً ويحتفظ بمرجعه وسجله والاعتمادات الممنوحة حتى الآن — ولا يُعدّ مرفوضاً.",
    "whatShouldChange": "ما الذي يجب تغييره",
    "whatShouldChangeHint": "مطلوب. يراه مقدّم الطلب على أنه ما يجب عليه فعله.",
    "instructionRequired": "اذكر ما الذي يجب تغييره.",
    "rejectDialogTitle": "رفض هذا الطلب؟",
    "rejectExplains": "الرفض يُنهي الطلب، ولا يمكن إعادة تقديمه بهذا المرجع.",
    "rejectAlternative": "إن كان يمكن تصحيحه، فأعده للتعديل بدلاً من ذلك: يبقى مفتوحاً ويحتفظ بسجله.",
    "returnInstead": "إعادة للتعديل بدلاً من ذلك",
    "rejectCommit": "رفض الطلب",
    "whyTitle": "لماذا يحتاج هذا الطلب إلى قرار",
    "panelTitle": "قرارك",
    "workflowTitle": "مسار الاعتماد",
    "budgetUnavailable": "سياق الميزانية غير متاح لهذا الطلب.",
    "decide": "اتخاذ القرار",
    "selfTitle": "أنت مقدّم هذا الطلب",
    "selfBody": "لا تسمح قواعد الشراء باعتماد طلبك بنفسك. الطلب لدى {{holder}}. لم يُسجَّل شيء.",
    "sodTitle": "يلزم معتمد مختلف",
    "sodBody": "سبق أن اتخذت قراراً في مستوى سابق لهذا الطلب، وكل مستوى يتطلب معتمداً مختلفاً. لم يُسجَّل شيء.",
    "staleTitle": "تغيّر وضع هذا الاعتماد",
    "staleBy": "اتخذ {{name}} القرار في {{at}}. لم يُسجَّل شيء باسمك.",
    "staleUnknown": "اتخذ شخص آخر القرار أثناء مراجعتك. لم يُسجَّل شيء باسمك.",
    "reload": "إعادة التحميل",
    "notYoursTitle": "لا ينتظر قرارك",
    "notYoursBody": "لا يتخذ القرار إلا معتمد هذا المستوى. الطلب لدى {{holder}}.",
    "submitted": "قُدّم في {{date}} بواسطة {{name}}",
    "requestTotal": "إجمالي الطلب",
    "sources": "المصادر",
    "item": "الصنف",
    "quantity": "الكمية",
    "unitPrice": "سعر الوحدة",
    "lineTotal": "إجمالي البند شاملًا الضريبة",
    "offCatalogue": "خارج الكتالوج",
    "resultTitle": "تم تسجيل القرار",
    "result": {
      "approve": "تم الاعتماد",
      "partial_approve": "تم الاعتماد جزئياً",
      "return": "أُعيد للتعديل",
      "reject": "تم الرفض"
    },
    "resultBy": "بواسطة {{name}} في {{at}}.",
    "resultByFor": "بواسطة {{name}} نيابةً عن {{for}} في {{at}}.",
    "nowAt": "حالة الطلب الآن: {{status}}.",
    "backToQueue": "العودة إلى الاعتمادات",
    "openRequest": "فتح الطلب",
    "overdueTitle": "تجاوز مهلة الاعتماد",
    "overdueSince": "كان مستحقاً في {{date}}.",
    "slaRule": "مهلة الاعتماد",
    "validUntil": "صالحة حتى {{date}}"
  },
  "amend": {
    "title": "تعديل {{number}} — الإصدار {{next}}",
    "stepOf": "الخطوة {{step}} من {{count}} · {{name}}",
    "stepName": {
      "intro": "ماذا يعني التعديل",
      "edit": "صياغة الإصدار الجديد",
      "review": "مراجعة التغييرات",
      "confirm": "التأكيد"
    },
    "creates": "ينشئ التعديل الإصدار {{next}} من {{number}}.",
    "keeps": "يبقى الإصدار {{current}} في السجل مستنداً صادراً يمكن قراءته دائماً. ولا يتغيّر شيء مما استُلم أو فُوتر.",
    "currentVersion": "الإصدار الحالي",
    "currentVersionValue": "الإصدار {{version}} · صدر في {{date}}",
    "supplierAck": "تأكيد المورد",
    "ackConfirmed": "مؤكَّد على الإصدار {{version}}",
    "ackOlder": "أكّد المورد الإصدار {{version}} فقط",
    "ackOutstanding": "لم يُؤكَّد الإصدار {{version}} بعد",
    "receivedSoFar": "المستلم حتى الآن",
    "invoicedSoFar": "المفوتر حتى الآن",
    "retained": "{{what}} · يبقى كما هو",
    "nothingReceived": "لم يُستلم شيء بعد",
    "nothingInvoiced": "لا فاتورة مسجّلة",
    "consequenceNew": "سيُنشأ إصدار جديد: الإصدار {{next}}.",
    "consequenceKept": "يبقى الإصدار {{current}} سجلاً تاريخياً قابلاً للقراءة.",
    "consequenceAckMaybe": "إذا تغيّرت كمية أو التاريخ المطلوب، يُلغى تأكيد المورد ويُطلب منه الرد من جديد.",
    "consequenceAckReset": "يُلغى تأكيد المورد: يُرسل إليه الإصدار {{next}} ويُطلب منه الرد من جديد، ويتوقف رابطه السابق عن العمل.",
    "consequenceAckKept": "تتغيّر الملاحظات فقط: يبقى تأكيد المورد قائماً ولا تُرسل رسالة جديدة.",
    "consequenceControls": "تبقى كل كمية ضمن ما اعتُمد ولا تقل عمّا استُلم — ويُتحقق من ذلك مجدداً عند التأكيد. ويتغيّر الالتزام في الميزانية بمقدار الفرق.",
    "start": "بدء التعديل",
    "draftTitle": "صياغة الإصدار {{next}}",
    "draftBody": "يبقى الإصدار {{current}} هو الأمر الصادر حتى تؤكّد. ولا يرى المورد أي تغيير بعد.",
    "orderedReceived": "المطلوب {{ordered}} · المستلم {{received}}",
    "locked": "لم يبقَ شيء للتسليم — هذا البند مقفل.",
    "quantityFor": "الكمية في الإصدار {{next}}",
    "quantityForLine": "الكمية في الإصدار {{next}} — {{name}}",
    "boundsReceived": "من {{min}} (المستلم) حتى {{max}} (المعتمد).",
    "boundsNone": "أكثر من 0، حتى {{max}} (المعتمد).",
    "problem": {
      "invalid": "أدخل رقماً، مثل 4 أو 2.5.",
      "positive": "أدخل كمية أكبر من 0. لإيقاف الأمر بالكامل، ألغِه بدلاً من ذلك.",
      "below_received": "لا تقل عن {{min}}: استُلمت هذه الكمية بالفعل.",
      "above_approved": "لا تزيد على {{max}}: هذه هي الكمية المعتمدة في الطلب."
    },
    "requiredBy": "التسليم المطلوب بحلول",
    "notes": "ملاحظات الأمر",
    "notesHint": "تُطبع على مستند الأمر. تغيير الملاحظات وحده لا يلغي تأكيد المورد.",
    "nothingYet": "غيّر كمية أو التاريخ أو الملاحظات لصياغة إصدار جديد.",
    "discard": "تجاهل المسودة",
    "review": "مراجعة التغييرات",
    "reviewTitle": "مراجعة التغييرات — من الإصدار {{current}} إلى الإصدار {{next}}",
    "fieldQuantity": "{{name}} — الكمية",
    "effectReducedReceived": "خُفّضت بمقدار {{by}}. ولا تقل عن {{received}} المستلمة، لذا فهي مسموحة.",
    "effectReduced": "خُفّضت بمقدار {{by}}.",
    "effectIncreased": "زيدت بمقدار {{by}}، ضمن {{approved}} المعتمدة.",
    "effectEarlier": "تاريخ أبكر. يُلغي تأكيد المورد.",
    "effectLater": "تاريخ أبعد. يُلغي تأكيد المورد.",
    "effectNotes": "تغيير في الصياغة فقط.",
    "orderValue": "قيمة الأمر",
    "effectValueDown": "انخفضت بمقدار {{amount}}. ويُحرَّر من الالتزام المبلغ نفسه.",
    "effectValueUp": "زادت بمقدار {{amount}}. ويزيد الالتزام بالمبلغ نفسه.",
    "recalculated": "يعيد الخادم حساب الإجماليات بدقة عند التأكيد.",
    "backToEdit": "العودة إلى التعديل",
    "continue": "متابعة",
    "confirmBody": "يصبح الإصدار {{next}} هو الأمر الحالي بقيمة {{total}}. ويحلّ محل الإصدار {{current}} الذي يبقى محفوظاً مستنداً صادراً.",
    "unaffected": "لا تتأثر وتبقى مرتبطة بالأمر: {{evidence}}.",
    "invoiceRef": "الفاتورة {{number}}",
    "listSeparator": "، ",
    "noEvidenceYet": "لم يُستلم أو يُفوتر شيء على هذا الأمر بعد.",
    "reason": "سبب الإصدار الجديد",
    "reasonHint": "مطلوب. يُسجَّل مع الإصدار وفي سجل التدقيق.",
    "staleTitle": "تغيّر هذا الأمر أثناء عملك عليه",
    "staleBody": "غيّره شخص آخر أولاً، لذلك لم يصدر الإصدار {{next}}. ابدأ من جديد من أحدث إصدار.",
    "startAgain": "البدء من جديد من أحدث إصدار",
    "back": "رجوع",
    "issue": "إصدار الإصدار {{next}}",
    "doneTitle": "صدر الإصدار {{version}}",
    "doneBody": "{{when}} بواسطة {{name}}. وحلّ محل الإصدار {{previous}} الذي يبقى محفوظاً.",
    "doneSupplier": "يُرسل الإصدار {{version}} إلى المورد ويُطلب منه الرد من جديد.",
    "recordedChanges": "التغييرات المسجّلة",
    "backToOrder": "العودة إلى الأمر"
  },
  "cancel": {
    "title": "إلغاء {{number}}؟",
    "titleDraft": "إلغاء أمر المسودة هذا؟",
    "subtitle": "الإصدار {{version}} · {{supplier}}",
    "draftNoMoney": "لم يصدر هذا الأمر قط ولا يحمل أي التزام. إلغاؤه لا يحرّك أي أموال.",
    "lockedRule": "الإلغاء يحرّر الالتزام المتبقي غير المستلم فقط",
    "lockedRuleBody": "تبقى أدلة الاستلام والفوترة والسجل كما هي. لا يُحذف شيء ولا يُعكس.",
    "invoicesOutcome": "تبقى كما هي: {{numbers}}. مسجّلة على الأمر كاملاً.",
    "receivedTitle": "استُلمت بضائع على هذا الأمر",
    "linesAtCancellation": "البنود عند الإلغاء",
    "item": "الصنف",
    "notDelivered": "غير مسلَّم",
    "lineOutcome": {
      "fully_received": "مستلم بالكامل",
      "closed_short": "أُغلق بنقص سابقاً",
      "part_cancelled": "أُلغي جزئياً",
      "cancelled": "أُلغي"
    },
    "released": "المحرَّر",
    "retained": "المُبقى",
    "reason": "سبب الإلغاء",
    "reasonHint": "مطلوب. يظهر على الأمر وفي سجل التدقيق وفي الإشعار المرسل إلى المورد.",
    "theSupplier": "المورد",
    "staleTitle": "تغيّر هذا الأمر أثناء مراجعتك له",
    "staleReceipts": "استُلمت بضائع عليه في الأثناء، فتغيّر أثر الإلغاء. لم يُلغَ شيء — راجعه مجدداً.",
    "reviewAgain": "المراجعة مجدداً",
    "keepOpen": "إبقاء الأمر مفتوحاً",
    "commit": "إلغاء الأمر",
    "commitRelease": "إلغاء الأمر · تحرير {{amount}}",
    "done": "أُلغي {{number}}. وحُرِّر من الالتزام {{released}}.",
    "supplierTold": "يُبلَّغ {{supplier}}، ويتوقف رابطه إلى هذا الأمر عن العمل. ويبقى كل إصدار صادر قابلاً للقراءة.",
    "receivedKeeps": "ما وصل يبقى ملتزماً به لأنه أُنفق، ولا يعود إلى الميزانية إلا الجزء الذي لن يصل. تبقى أدلة الاستلام والفوترة والسجل كما هي، ولا يُحذف شيء ولا يُعكس.",
    "byBudget": "حسب الميزانية",
    "budget": "الميزانية",
    "notBudgeted": "خارج الميزانيات",
    "unbudgeted": "{{amount}} من هذا الأمر خارج أي ميزانية، فلا يتحرك شيء لأجله.",
    "notCancellable": "أُغلق هذا الأمر ولم يعد ممكناً إلغاؤه.",
    "refusedTitle": "لا يمكن إلغاء هذا الأمر حتى تُراجَع حركات ميزانيته",
    "ledgerDisagrees": "{{budget}}: يحمل السجل {{held}}، بينما تفسّر بنود الأمر {{expected}}.",
    "staleConsequences": "تغيّر أثر الإلغاء على الميزانية في الأثناء بسبب استلام أو إغلاق بنقص أو تعديل. لم يُلغَ شيء، راجعه مجدداً."
  },
  "platform": {
    "shellBadge": "عمليات المنصة",
    "reviewNotice": "وحدة تحكم المشغّل لمراجعة المالك محلياً، مركّبة من مكوّنات فيدلِن المشتركة. ليست تصميماً معتمداً وليست إصداراً.",
    "nav": {
      "label": "عمليات المنصة",
      "overview": "نظرة عامة",
      "organisations": "المنشآت",
      "security": "أمان تسجيل الدخول"
    },
    "login": {
      "title": "دخول مشغّل فيدلِن",
      "subtitle": "لفريق فيدلِن الذي يشغّل المنصة. يدخل العملاء والموردون من مكان آخر.",
      "boundary": "لا يمنح هذا الدخول أي وصول إلى مشتريات العميل أو بوابة المورد."
    },
    "tenantStatus": {
      "provisioning": "قيد الإعداد",
      "active": "نشطة",
      "suspended": "موقوفة",
      "closed": "مغلقة"
    },
    "overview": {
      "title": "نظرة عامة على المنصة",
      "subtitle": "ما تقوله سجلات المنصة نفسها اليوم.",
      "organisations": "المنشآت",
      "activeNote": "{{count}} نشطة",
      "pendingAdministrators": "مسؤولون لم يُفعَّلوا بعد",
      "pendingNote": "دُعوا ولم يسجّلوا الدخول بعد",
      "pilots": "التجارب",
      "pilotsNote": "سجلات التجارب بجميع حالاتها",
      "subscriptions": "الاشتراكات",
      "subscriptionsNote": "سجلات الاشتراكات بجميع حالاتها",
      "byStatus": "المنشآت حسب الحالة",
      "howToRead": "كيف تُقرأ هذه الأرقام",
      "defOrganisations": "يُحتسب في المنشآت كل منشأة جرى إعدادها، حسب حالة دورة حياتها.",
      "defPending": "يُحتسب في المسؤولين غير المفعّلين كل منشأة لم يضع مسؤولها الأول كلمة مرور بعد.",
      "defPilots": "التجارب والاشتراكات أعداد سجلات، لا إيرادات.",
      "defNoRevenue": "لا يُعرض أي رقم إيرادات أو إنفاق أو بنية تحتية: لا تحتفظ المنصة بإسقاط معتمد لها."
    },
    "orgs": {
      "title": "المنشآت",
      "subtitle": "كل منشأة عميلة على المنصة. مشترياتها تخصّها؛ تعرض هذه القائمة من هي وأين تقف.",
      "create": "إنشاء منشأة",
      "search": "ابحث بالاسم أو المعرّف",
      "status": "الحالة",
      "allStatuses": "كل الحالات",
      "empty": "لا توجد منشآت بعد.",
      "emptyFiltered": "لا توجد منشأة تطابق هذا البحث.",
      "organisation": "المنشأة",
      "administrator": "المسؤول الأول",
      "commercial": "الخطة أو التجربة",
      "created": "أُنشئت"
    },
    "org": {
      "pilot": "تجربة",
      "noPlan": "بلا خطة",
      "adminActivated": "مفعّل",
      "adminInvited": "بانتظار قبول الدعوة",
      "tabs": {
        "label": "أقسام المنشأة",
        "overview": "نظرة عامة",
        "commercial": "الاشتراك والسعة",
        "onboarding": "الإعداد",
        "history": "السجل"
      },
      "identity": "المنشأة",
      "nameEn": "الاسم (بالإنجليزية)",
      "nameAr": "الاسم (بالعربية)",
      "legalName": "الاسم القانوني",
      "cr": "السجل التجاري",
      "vat": "الرقم الضريبي",
      "defaults": "اللغة · العملة · المنطقة الزمنية",
      "created": "أُنشئت",
      "onboarded": "اكتمل إنشاؤها على المنصة",
      "notYet": "ليس بعد",
      "administrator": "المسؤول الأول",
      "noAdministrator": "لا يوجد مسؤول مسجّل.",
      "adminName": "الاسم",
      "adminEmail": "البريد الإلكتروني",
      "adminState": "الحالة",
      "invitationExpires": "تنتهي الدعوة",
      "resend": "إعادة إرسال الدعوة",
      "resendTitle": "إعادة إرسال دعوة المسؤول؟",
      "resendBody": "يُرسل رابط دعوة جديد ويتوقف الرابط السابق فوراً. لا يُنشأ مسؤول ثانٍ.",
      "resendCommit": "إعادة إرسال الدعوة",
      "resent": "صدرت دعوة جديدة. لم يعد الرابط السابق يعمل.",
      "subscription": "الاشتراك",
      "noSubscription": "لا يوجد اشتراك مسجّل.",
      "plan": "الخطة",
      "subscriptionStatus": "الحالة",
      "starts": "يبدأ",
      "ends": "ينتهي",
      "noPilot": "لا توجد تجربة مسجّلة.",
      "pilotStatus": "حالة التجربة",
      "pilotDays": "أيام التجربة",
      "liveAt": "بدأ التشغيل",
      "configurationDeadline": "موعد انتهاء الإعداد",
      "capacity": "سعة وحدات الشراء",
      "capacityHint": "وحدات الشراء النشطة مقابل حدّ الخطة.",
      "capacityUsed": "المستخدم",
      "capacityLimit": "الحدّ",
      "capacityRemaining": "المتبقي",
      "unlimited": "بلا حدّ",
      "atCapacity": "بلغت هذه المنشأة حدّ وحدات الشراء.",
      "notInScope": "خارج وحدة التحكم هذه",
      "notInScopeBody": "لا تُشغَّل الفوترة والتحصيل والخصومات وتغيير الخطط من وحدة المراجعة هذه. مرحلة إصدار الميزات التجارية قرار مفتوح لدى المالك.",
      "setup": "تقدّم الإعداد",
      "setupProgress": "اكتمل {{complete}} من {{required}} خطوة مطلوبة",
      "required": "مطلوبة",
      "historyTitle": "السجل التجاري",
      "historyHint": "الأحداث التجارية المسجّلة لهذه المنشأة، الأحدث أولاً.",
      "noHistory": "لا توجد أحداث تجارية بعد."
    },
    "create": {
      "title": "إنشاء منشأة",
      "subtitle": "إعداد منشأة عميلة ودعوة مسؤولها الأول.",
      "organisation": "المنشأة",
      "slug": "المعرّف",
      "slugHint": "أحرف إنجليزية صغيرة وأرقام وشرطات. يُستخدم لتسجيل الدخول ولا يمكن إعادة استخدامه.",
      "commercialContext": "السياق التجاري",
      "commercialContextHint": "تبدأ التجربة على ملف التجربة؛ وتبدأ المرحلة الأولى على الخطة الكاملة.",
      "contextPilot": "تجربة",
      "contextLayer1": "خطة المرحلة الأولى",
      "defaultLanguage": "اللغة الافتراضية",
      "languageAr": "العربية",
      "languageEn": "الإنجليزية",
      "administrator": "المسؤول الأول",
      "administratorHint": "تصله دعوة ليضع كلمة المرور بنفسه.",
      "syntheticOnly": "في بيئة المراجعة هذه استخدم أسماء وعناوين تجريبية فقط. تذهب الدعوة إلى صندوق البريد المحلي، لا إلى بريد حقيقي.",
      "commit": "إنشاء المنشأة والدعوة",
      "doneTitle": "أُنشئت المنشأة",
      "invitationHanded": "سُلّمت الدعوة إلى ناقل البريد. وهذا ليس دليلاً على وصولها أو قراءتها.",
      "invitationNotSent": "المنشأة موجودة، لكن الدعوة لم تُرسل. أعد إرسالها من صفحة المنشأة عندما يعمل البريد.",
      "whatHappened": "ما الذي أُنشئ",
      "nextStep": "يفعّل المسؤول الحساب من الدعوة ثم يُعدّ المنشأة. لا يمكنها إصدار طلبات قبل اكتمال الإعداد.",
      "open": "فتح المنشأة"
    }
  }
}
